import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut, updatePassword,createUserWithEmailAndPassword } from 'firebase/auth';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

import { doc, getDoc, updateDoc, addDoc,setDoc , deleteDoc, collection, getDocs, orderBy , query, where, onSnapshot,arrayUnion,serverTimestamp   } from 'firebase/firestore';

import { db } from '../components/firebase-config.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHome, faUserMd, faUser, faCalendarAlt, faKey, faBars, faSignOutAlt,
  faEdit, faEye,faFilter ,faLock ,faUnlock ,faHistory ,faTrash , faCalendarDay,faArrowLeft , faCalendarWeek, faChevronLeft, faChevronRight,
  faClock, faPhone, faEnvelope, faClinicMedical,faBroom ,faBuilding , faCheckCircle,faUserPlus ,faCalendarPlus ,faCheck , faTimesCircle,
  faExclamationCircle, faList, faCalendarCheck, faSearch, faLink, faUnlink, faSync,  faArchive,
   faFileAlt, faTrashAlt, faSave, faFileUpload, faFileDownload,
  faTimes, faMapMarkerAlt, faRedo,


  faComments, faComment, faPaperPlane, faCircleNotch, faUserFriends,
  faPaperclip, faMicrophone, faStop, faFile,
  faDownload

} from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import './MedecinDashboard.css';
import { initializeApp } from 'firebase/app';
import MedecinPatientManager from './MedecinPatientManager.js';



const MedecinDashboard = () => {
  // États pour les données
  const storage = getStorage();
  const auth = getAuth();
  const navigate = useNavigate();

  const [medecinData, setMedecinData] = useState(null);
  const [form, setForm] = useState({});
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [activeTab, setActiveTab] = useState('rendezvous');
  const [rendezvous, setRendezvous] = useState([]);
  const [patients, setPatients] = useState([]);
  const [structures, setStructures] = useState([]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 999);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [mobileDetailView, setMobileDetailView] = useState(null);
  const [affiliatedStructures, setAffiliatedStructures] = useState([]);
  const [pendingAffiliations, setPendingAffiliations] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showPatientModal, setShowPatientModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [unsubscribeFunctions, setUnsubscribeFunctions] = useState([]);
  const [disaffiliationHistory, setDisaffiliationHistory] = useState([]);
  const [showModal, setShowModal] = useState(false);
const [mobileMessageTab, setMobileMessageTab] = useState('conversations');
const [error, setError] = useState(null);
const [patientSubTab, setPatientSubTab] = useState('list');

const [conversations, setConversations] = useState([]);
const [selectedConversation, setSelectedConversation] = useState(null);
const [messages, setMessages] = useState([]);
const [newMessage, setNewMessage] = useState('');
const [loadingMessages, setLoadingMessages] = useState(false);
const [sendingMessage, setSendingMessage] = useState(false);
const messagesEndRef = useRef(null);
const [messagePatients, setMessagePatients] = useState([]);
const [searchPatientTerm, setSearchPatientTerm] = useState('');

// États pour la vue calendrier
const [calendarView, setCalendarView] = useState('month');
const [currentMonth, setCurrentMonth] = useState(new Date());
const [selectedDate, setSelectedDate] = useState(null);
const [showDateModal, setShowDateModal] = useState(false);
const [showRdvDetailsModal, setShowRdvDetailsModal] = useState(false);
const [selectedRdv, setSelectedRdv] = useState(null);
const [searchStructure, setSearchStructure] = useState('');
const [filtreSpecialite, setFiltreSpecialite] = useState('');
const [rejectedAffiliations, setRejectedAffiliations] = useState([]);
const [specialites, setSpecialites] = useState([]);
const [allStructures, setAllStructures] = useState([]);
const [sentAffiliationRequests, setSentAffiliationRequests] = useState([]);
const [editingStatus, setEditingStatus] = useState(false);
const [newStatus, setNewStatus] = useState('');

// États pour les archives
const [archives, setArchives] = useState([]);
const [selectedArchive, setSelectedArchive] = useState(null);
const [archiveNotes, setArchiveNotes] = useState('');
const [archiveFiles, setArchiveFiles] = useState([]);
const [showArchiveModal, setShowArchiveModal] = useState(false);
const [searchArchive, setSearchArchive] = useState('');
// Ajoutez cet état avec les autres déclarations d'états au début de votre composant
const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

// 1. Ajoutez ces états pour gérer l'affichage des détails
const [showDetails, setShowDetails] = useState(false);
const [detailsType, setDetailsType] = useState(null); // 'patient', 'rdv', 'archive', etc.
const [detailsItem, setDetailsItem] = useState(null);

// Dans les déclarations d'état (useState), ajouter:
const [attachmentFile, setAttachmentFile] = useState(null);
const [isRecording, setIsRecording] = useState(false);
const [audioBlob, setAudioBlob] = useState(null);
const [mediaRecorder, setMediaRecorder] = useState(null);
const [recordingTime, setRecordingTime] = useState(0);
const [recordingTimer, setRecordingTimer] = useState(null);


const loadMessagePatients = async () => {
  try {
    if (!auth.currentUser) return;
    
    // Récupérer les patients des structures affiliées
    const patientsMap = new Map();
    
    // Récupérer les patients des rendez-vous
    rendezvous.forEach(rdv => {
      if (rdv.patientId && !patientsMap.has(rdv.patientId)) {
        const patient = patients.find(p => p.id === rdv.patientId);
        if (patient) {
          patientsMap.set(rdv.patientId, patient);
        }
      }
    });
    
    // Récupérer également les patients des conversations existantes
    const conversationsQuery = query(
      collection(db, 'conversations'),
      where('participants', 'array-contains', auth.currentUser.uid)
    );
    
    const conversationsSnapshot = await getDocs(conversationsQuery);
    const conversationsList = [];
    
    for (const docSnapshot of conversationsSnapshot.docs) {
      const conversationData = docSnapshot.data();
      // Trouver l'ID de l'autre participant (patient)
      const otherParticipantId = conversationData.participants.find(
        id => id !== auth.currentUser.uid
      );
      
      if (otherParticipantId && !patientsMap.has(otherParticipantId)) {
        // Récupérer les informations du patient
        const patientDoc = await getDoc(doc(db, 'patients', otherParticipantId));
        if (patientDoc.exists()) {
          patientsMap.set(otherParticipantId, {
            id: otherParticipantId,
            ...patientDoc.data()
          });
        }
      }
      
      // Ajouter la conversation à la liste
      if (otherParticipantId) {
        const patient = patientsMap.get(otherParticipantId) || { id: otherParticipantId, nom: "Patient inconnu", prenom: "" };
        conversationsList.push({
          id: docSnapshot.id,
          ...conversationData,
          patient: patient,
          unreadCount: conversationData.unreadBy && 
            conversationData.unreadBy.includes(auth.currentUser.uid) ? 1 : 0
        });
      }
    }
    
    // Mettre à jour l'état des conversations
    setConversations(conversationsList);
    
    // Convertir la Map en tableau pour l'état
    setMessagePatients(Array.from(patientsMap.values()));
    
  } catch (error) {
    console.error("Erreur lors du chargement des patients pour la messagerie:", error);
  }
};

// Charger les patients pour la messagerie quand l'onglet messagerie est actif
useEffect(() => {
  if (activeTab === 'messagerie') {
    loadMessagePatients();
  }
}, [activeTab, patients, rendezvous]);

// Fonction pour charger les messages d'une conversation
const fetchMessages = async (conversationId) => {
  if (!conversationId) return () => {};
  
  setLoadingMessages(true);
  try {
    const messagesQuery = query(
      collection(db, 'conversations', conversationId, 'messages'),
      orderBy('timestamp', 'asc')
    );
    
    const unsubscribe = onSnapshot(messagesQuery, (snapshot) => {
      const messagesList = snapshot.docs.map(docSnapshot => ({
        id: docSnapshot.id,
        ...docSnapshot.data()
      }));
      
      setMessages(messagesList);
      setLoadingMessages(false);
      
      // Marquer les messages comme lus
      markConversationAsRead(conversationId);
      
      // Scroll to bottom
      setTimeout(() => {
        if (messagesEndRef.current) {
          messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    });
    
    return unsubscribe;
  } catch (err) {
    console.error("Erreur lors du chargement des messages:", err);
    setError("Impossible de charger les messages.");
    setLoadingMessages(false);
    return () => {};
  }
};

// Marquer une conversation comme lue
const markConversationAsRead = async (conversationId) => {
  try {
    const conversationRef = doc(db, 'conversations', conversationId);
    const conversationSnapshot = await getDoc(conversationRef);
    
    if (conversationSnapshot.exists()) {
      const data = conversationSnapshot.data();
      if (data.unreadBy && data.unreadBy.includes(auth.currentUser.uid)) {
        // Retirer l'ID du médecin de unreadBy
        await updateDoc(conversationRef, {
          unreadBy: data.unreadBy.filter(id => id !== auth.currentUser.uid)
        });
        
        // Mettre à jour localement
        setConversations(prevConversations => 
          prevConversations.map(conv => 
            conv.id === conversationId ? {...conv, unreadCount: 0} : conv
          )
        );
      }
    }
  } catch (err) {
    console.error("Erreur lors du marquage de la conversation comme lue:", err);
  }
};

// Fonction pour gérer le changement de fichier
const handleMessageFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  setAttachmentFile(file);
};

// Fonction pour démarrer l'enregistrement vocal
const startRecording = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const recorder = new MediaRecorder(stream);
    const chunks = [];

    recorder.ondataavailable = (e) => {
      if (e.data.size > 0) {
        chunks.push(e.data);
      }
    };

    recorder.onstop = () => {
      const blob = new Blob(chunks, { type: 'audio/webm' });
      setAudioBlob(blob);
      // Arrêter tous les tracks du stream
      stream.getTracks().forEach(track => track.stop());
    };

    // Démarrer l'enregistrement
    recorder.start();
    setMediaRecorder(recorder);
    setIsRecording(true);
    
    // Démarrer le timer
    const timer = setInterval(() => {
      setRecordingTime(prev => prev + 1);
    }, 1000);
    setRecordingTimer(timer);
    
  } catch (error) {
    console.error("Erreur lors de l'accès au microphone:", error);
  }
};

// Fonction pour arrêter l'enregistrement vocal
const stopRecording = () => {
  if (mediaRecorder && mediaRecorder.state !== 'inactive') {
    mediaRecorder.stop();
    setIsRecording(false);
    
    // Arrêter le timer
    if (recordingTimer) {
      clearInterval(recordingTimer);
      setRecordingTimer(null);
    }
  }
};

// Fonction pour annuler l'enregistrement
const cancelRecording = () => {
  if (mediaRecorder && mediaRecorder.state !== 'inactive') {
    mediaRecorder.stop();
  }
  
  setIsRecording(false);
  setAudioBlob(null);
  setRecordingTime(0);
  
  if (recordingTimer) {
    clearInterval(recordingTimer);
    setRecordingTimer(null);
  }
};

// Fonction pour supprimer le fichier attaché
const removeAttachment = () => {
  setAttachmentFile(null);
};

// Fonction pour supprimer l'audio enregistré
const removeAudio = () => {
  setAudioBlob(null);
  setRecordingTime(0);
};

// Fonction formatant le temps d'enregistrement
const formatRecordingTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};

// Modifier la fonction sendMessage
const sendMessage = async (e) => {
  e.preventDefault();
  
  if ((!newMessage.trim() && !attachmentFile && !audioBlob) || !selectedConversation || sendingMessage) {
    return;
  }
  
  setSendingMessage(true);
  try {
    const messageData = {
      text: newMessage.trim(),
      senderId: auth.currentUser.uid,
      senderName: `Dr. ${medecinData.prenom} ${medecinData.nom}`,
      timestamp: serverTimestamp(),
      read: false
    };
    
    // Si un fichier est attaché, l'uploader d'abord
    if (attachmentFile) {
      const fileRef = ref(storage, `conversations/${selectedConversation.id}/${Date.now()}_${attachmentFile.name}`);
      await uploadBytes(fileRef, attachmentFile);
      const downloadURL = await getDownloadURL(fileRef);
      
      messageData.attachment = {
        url: downloadURL,
        name: attachmentFile.name,
        type: attachmentFile.type,
        size: attachmentFile.size
      };
    }
    
    // Si un enregistrement audio est présent, l'uploader
    if (audioBlob) {
      const fileName = `audio_${Date.now()}.webm`;
      const audioRef = ref(storage, `conversations/${selectedConversation.id}/${fileName}`);
      await uploadBytes(audioRef, audioBlob);
      const downloadURL = await getDownloadURL(audioRef);
      
      messageData.audioAttachment = {
        url: downloadURL,
        name: fileName,
        type: 'audio/webm',
        duration: recordingTime
      };
    }
    
    // Ajouter le message à la collection
    await addDoc(collection(db, 'conversations', selectedConversation.id, 'messages'), messageData);
    
    // Mettre à jour la conversation avec le dernier message
    const conversationRef = doc(db, 'conversations', selectedConversation.id);
    await updateDoc(conversationRef, {
      lastMessage: messageData.text || (attachmentFile ? "Pièce jointe" : "Note vocale"),
      lastMessageAt: serverTimestamp(),
      // Marquer comme non lu pour le patient
      unreadBy: [selectedConversation.patient.id]
    });
    
    // Réinitialiser les champs
    setNewMessage('');
    setAttachmentFile(null);
    setAudioBlob(null);
    setRecordingTime(0);
    
  } catch (err) {
    console.error("Erreur lors de l'envoi du message:", err);
  } finally {
    setSendingMessage(false);
  }
};

// Créer ou sélectionner une conversation avec un patient
const startConversationWithPatient = async (patient) => {
  try {
    // Vérifier si une conversation existe déjà
    const existingConvQuery = query(
      collection(db, 'conversations'),
      where('participants', 'in', [[auth.currentUser.uid, patient.id].sort(), [patient.id, auth.currentUser.uid].sort()])
    );
    
    const existingConvSnapshot = await getDocs(existingConvQuery);
    
    if (!existingConvSnapshot.empty) {
      // Une conversation existe déjà, la sélectionner
      const existingConvDoc = existingConvSnapshot.docs[0];
      const existingConvData = existingConvDoc.data();
      
      setSelectedConversation({
        id: existingConvDoc.id,
        ...existingConvData,
        patient: patient
      });
      
      // Charger les messages de cette conversation
      const unsubscribe = await fetchMessages(existingConvDoc.id);
      return () => {
        if (typeof unsubscribe === 'function') unsubscribe();
      };
    }
    
    // Créer une nouvelle conversation
    const newConversationRef = await addDoc(collection(db, 'conversations'), {
      participants: [auth.currentUser.uid, patient.id].sort(),
      createdAt: serverTimestamp(),
      lastMessageAt: serverTimestamp(),
      lastMessage: "",
      unreadBy: []
    });
    
    // Sélectionner la nouvelle conversation
    setSelectedConversation({
      id: newConversationRef.id,
      participants: [auth.currentUser.uid, patient.id].sort(),
      patient: patient,
      lastMessage: "",
      unreadCount: 0
    });
    
    // Charger les messages (vides pour l'instant)
    const unsubscribe = await fetchMessages(newConversationRef.id);
    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
    
  } catch (err) {
    console.error("Erreur lors de la création de la conversation:", err);
    return () => {};
  }
};

// Charger les messages lorsqu'une conversation est sélectionnée
useEffect(() => {
  let unsubscribeFunction = null;
  
  if (selectedConversation) {
    const loadMessages = async () => {
      unsubscribeFunction = await fetchMessages(selectedConversation.id);
    };
    
    loadMessages();
  }
  
  return () => {
    if (typeof unsubscribeFunction === 'function') {
      unsubscribeFunction();
    }
  };
}, [selectedConversation?.id]);

// Filtrer les patients pour la messagerie selon la recherche
const filteredMessagePatients = useMemo(() => {
  return messagePatients.filter(patient => {
    const fullName = `${patient.prenom} ${patient.nom}`.toLowerCase();
    return fullName.includes(searchPatientTerm.toLowerCase());
  });
}, [messagePatients, searchPatientTerm]);



useEffect(() => {
  if (!auth.currentUser?.uid) return;
  
  // Créer une requête pour récupérer les conversations avec des messages non lus
  const unreadConversationsQuery = query(
    collection(db, 'conversations'),
    where("unreadBy", "array-contains", auth.currentUser.uid)
  );
  
  // Écouter les changements
  const unsubscribe = onSnapshot(unreadConversationsQuery, (snapshot) => {
    setUnreadMessagesCount(snapshot.docs.length);
    
    // Si des conversations non lues sont détectées et que l'utilisateur n'est pas sur l'onglet messagerie
    if (snapshot.docs.length > 0 && activeTab !== 'messagerie') {
      // Ajouter une notification visuelle ou sonore ici si nécessaire
      const audio = new Audio('/notification-sound.mp3'); // Assurez-vous que ce fichier existe
      audio.play().catch(e => console.log("Lecture audio impossible:", e));
    }
  });
  
  return () => unsubscribe();
}, [auth.currentUser, activeTab]);

// Au début de votre composant ou dans un useEffect
useEffect(() => {
  // S'assurer que window.bootstrap existe
  if (typeof window !== 'undefined' && window.bootstrap) {
    // Bootstrap est disponible
  } else {
    console.error("Bootstrap n'est pas disponible globalement");
  }
}, []);
// Ajoutez ceci à la fin de vos useEffects
useEffect(() => {
  const handleViewPatientEvent = (e) => {
    handleViewDetails('patient', e.detail);
  };
  
  const handleViewRdvEvent = (e) => {
    handleViewDetails('rdv', e.detail);
  };
  
  // Ajouter les écouteurs d'événements
  document.addEventListener('viewPatient', handleViewPatientEvent);
  document.addEventListener('viewRdv', handleViewRdvEvent);
  
  // Nettoyer les écouteurs à la destruction du composant
  return () => {
    document.removeEventListener('viewPatient', handleViewPatientEvent);
    document.removeEventListener('viewRdv', handleViewRdvEvent);
  };
}, []);

  const [filtreDate, setFiltreDate] = useState(() => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  });
  const [filtreStatut, setFiltreStatut] = useState('tous');
  const [filtreStructure, setFiltreStructure] = useState('');
  const [viewMode, setViewMode] = useState('calendar');
  
  // Gestion de la taille de l'écran
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 999);
      if (window.innerWidth < 999) {
        setSidebarCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

// Écouteur pour les structures affiliées
const setupAffiliatedStructuresListener = (medecinId) => {
  // Requête pour les affiliations acceptées
  const affiliationsQuery = query(
    collection(db, 'affiliationRequests'),
    where("medecinId", "==", medecinId),
    where("status", "in", ["accepted"]) // Accepter les deux valeurs possibles
  );
  
  return onSnapshot(affiliationsQuery, async (snapshot) => {
    try {
      const structureIds = [];
      snapshot.forEach((doc) => {
        structureIds.push(doc.data().structureId);
      });
      
      // Si aucune structure affiliée, mettre à jour l'état immédiatement
      if (structureIds.length === 0) {
        setAffiliatedStructures([]);
        return;
      }
      
      // Récupérer les données des structures
      const structures = [];
      for (const structureId of structureIds) {
        const structureDoc = await getDoc(doc(db, 'structures', structureId));
        if (structureDoc.exists()) {
          structures.push({
            id: structureId,
            ...structureDoc.data()
          });
        }
      }
      
      setAffiliatedStructures(structures);
      console.log("Structures affiliées mises à jour:", structures); // Ajout de log pour débogage
    } catch (error) {
      console.error("Erreur lors de la récupération des structures affiliées:", error);
    }
  }, (error) => {
    console.error("Erreur d'écoute des structures affiliées:", error);
  });
};


  // Écouteur pour les demandes d'affiliation en attente
  const setupPendingAffiliationsListener = (medecinId) => {
    const affiliationsQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", medecinId),
      where("status", "==", "pending")
    );
    
    return onSnapshot(affiliationsQuery, async (snapshot) => {
      try {
        const requests = [];
        const previousLength = pendingAffiliations.length;
        
        for (const docRef of snapshot.docs) {
          const requestData = docRef.data();
          // Récupérer les informations de la structure
          const structureDoc = await getDoc(doc(db, 'structures', requestData.structureId));
          
          if (structureDoc.exists()) {
            requests.push({
              id: docRef.id,
              ...requestData,
              structureName: structureDoc.data().nom
            });
          }
        }
        
        setPendingAffiliations(requests);
        
        // Si de nouvelles demandes sont arrivées et que l'utilisateur n'est pas sur l'onglet affiliations
        if (requests.length > previousLength && activeTab !== 'affiliations') {
          // Notification sonore
          const audio = new Audio('/notification-sound.mp3');
          audio.play().catch(e => console.log("Lecture audio impossible:", e));
          
          // Afficher un message temporaire
          setMessage(`Vous avez ${requests.length} demande(s) d'affiliation en attente`);
          setTimeout(() => {
            if (message === `Vous avez ${requests.length} demande(s) d'affiliation en attente`) {
              setMessage('');
            }
          }, 5000);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des demandes d'affiliation:", error);
      }
    }, (error) => {
      console.error("Erreur d'écoute des demandes d'affiliation:", error);
    });
  };

  // Écouteur pour les demandes d'affiliation rejetées
  const setupRejectedAffiliationsListener = (medecinId) => {
    const affiliationsQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", medecinId),
      where("status", "==", "rejected")
    );
    
    return onSnapshot(affiliationsQuery, async (snapshot) => {
      try {
        const requests = [];
        
        snapshot.forEach((doc) => {
          requests.push({
            id: doc.id,
            ...doc.data()
          });
        });
        
        setRejectedAffiliations(requests);
      } catch (error) {
        console.error("Erreur lors de la récupération des demandes rejetées:", error);
      }
    }, (error) => {
      console.error("Erreur d'écoute des demandes rejetées:", error);
    });
  };

  // Écouteur pour toutes les structures
  const setupAllStructuresListener = () => {
    return onSnapshot(collection(db, 'structures'), (snapshot) => {
      try {
        const structuresData = [];
        const specialitesSet = new Set();
        
        snapshot.forEach((doc) => {
          const structureData = {
            id: doc.id,
            ...doc.data()
          };
          
          // Add check for specialites array
          if (Array.isArray(structureData.specialites)) {
            structureData.specialites.forEach(spec => specialitesSet.add(spec));
          } else {
            // Initialize as empty array if not present or not an array
            structureData.specialites = [];
          }
          
          structuresData.push(structureData);
        });
        
        setStructures(structuresData);
        setAllStructures(structuresData);
        setSpecialites(Array.from(specialitesSet).sort());
      } catch (error) {
        console.error("Erreur lors de la récupération des structures:", error);
      }
    }, (error) => {
      console.error("Erreur d'écoute des structures:", error);
    });
  };

  // Écouteur pour les rendez-vous
  const setupRendezvousListener = (medecinId) => {
    const rdvQuery = query(
      collection(db, 'rendezvous'),
      where("medecinId", "==", medecinId)
    );
    
    return onSnapshot(rdvQuery, (snapshot) => {
      try {
        const rdvData = [];
        snapshot.forEach((doc) => {
          // Normaliser la date lors du chargement
          const rdv = doc.data();
          if (rdv.date) {
            // S'assurer que la date est correctement formatée (YYYY-MM-DD)
            const dateObj = new Date(rdv.date);
            if (!isNaN(dateObj.getTime())) {
              rdv.date = formatDateString(dateObj);
            }
          }
          rdvData.push({ id: doc.id, ...rdv });
        });
        
        setRendezvous(rdvData);
      } catch (error) {
        console.error("Erreur lors de la récupération des rendez-vous:", error);
      }
    }, (error) => {
      console.error("Erreur d'écoute des rendez-vous:", error);
    });
  };

  // Écouteur pour les demandes d'affiliation envoyées
  const setupSentAffiliationRequestsListener = (medecinId) => {
    const affiliationsQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", medecinId),
      where("status", "in", ["pending", "rejected"])
    );
    
    return onSnapshot(affiliationsQuery, (snapshot) => {
      try {
        const requests = [];
        snapshot.forEach((doc) => {
          requests.push({
            id: doc.id,
            ...doc.data()
          });
        });
        
        setSentAffiliationRequests(requests);
      } catch (error) {
        console.error("Erreur lors de la récupération des demandes d'affiliation:", error);
      }
    }, (error) => {
      console.error("Erreur d'écoute des demandes d'affiliation:", error);
    });
  };


  // Écouteur pour les patients basé sur les rendez-vous
  useEffect(() => {
    if (rendezvous.length > 0) {
      const uniquePatientIds = new Set();
      rendezvous.forEach(rdv => {
        if (rdv.patientId) {
          uniquePatientIds.add(rdv.patientId);
        }
      });
      
      if (uniquePatientIds.size === 0) {
        setPatients([]);
        return;
      }
      
      // Créer un tableau de promesses pour récupérer les données des patients
      const fetchPatientPromises = Array.from(uniquePatientIds).map(async (patientId) => {
        try {
          const patientDoc = await getDoc(doc(db, 'patients', patientId));
          if (patientDoc.exists()) {
            return {
              id: patientId,
              ...patientDoc.data()
            };
          }
          return null;
        } catch (error) {
          console.error(`Erreur lors de la récupération du patient ${patientId}:`, error);
          return null;
        }
      });
      
      // Exécuter toutes les promesses
      Promise.all(fetchPatientPromises)
        .then(patientsData => {
          // Filtrer les valeurs null
          const validPatients = patientsData.filter(patient => patient !== null);
          setPatients(validPatients);
        })
        .catch(error => {
          console.error("Erreur lors de la récupération des patients:", error);
        });
    } else {
      setPatients([]);
    }
  }, [rendezvous]);

  // Filtrer les structures selon la recherche et la spécialité
  const filteredStructures = useMemo(() => {
    return allStructures.filter(structure => {
      const matchesSearch = searchStructure === '' || 
        structure.nom.toLowerCase().includes(searchStructure.toLowerCase()) ||
        (structure.description && structure.description.toLowerCase().includes(searchStructure.toLowerCase()));
      
      const matchesSpecialite = filtreSpecialite === '' || 
        (structure.specialites && structure.specialites.includes(filtreSpecialite));
      
      return matchesSearch && matchesSpecialite;
    });
  }, [allStructures, searchStructure, filtreSpecialite]);

  // Fonctions générales
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/auth');
    } catch (error) {
      console.error("Erreur lors de la déconnexion:", error);
    }
  };

  const handleUpdate = async () => {
    try {
      const user = auth.currentUser;
      await updateDoc(doc(db, 'medecins', user.uid), form);
      setMessage('Informations mises à jour avec succès.');
      
      // Afficher le message puis le faire disparaître après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const handlePasswordChange = async () => {
    try {
      const user = auth.currentUser;
      await updatePassword(user, newPassword);
      setMessage('Mot de passe mis à jour avec succès.');
      setNewPassword('');
      
      // Afficher le message puis le faire disparaître après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name.startsWith('disponibilites.')) {
      const [_, jour, prop] = name.split('.');
      setForm(prev => ({
        ...prev,
        disponibilites: {
          ...prev.disponibilites,
          [jour]: {
            ...prev.disponibilites[jour],
            [prop]: type === 'checkbox' ? checked : value
          }
        }
      }));
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  // Fonction pour basculer l'état du menu latéral
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const handleRequestAffiliation = async (structureId) => {
    try {
      const user = auth.currentUser;
      
      // Vérifier si une demande existe déjà
      const existingQuery = query(
        collection(db, 'affiliationRequests'),
        where("medecinId", "==", user.uid),
        where("structureId", "==", structureId)
      );
      
      const existingSnapshot = await getDocs(existingQuery);
      
      // Si des demandes existent, les supprimer d'abord
      const deletePromises = [];
      existingSnapshot.forEach((doc) => {
        deletePromises.push(deleteDoc(doc.ref));
      });
      
      // Attendre que toutes les suppressions soient terminées
      if (deletePromises.length > 0) {
        await Promise.all(deletePromises);
        console.log("Anciennes demandes d'affiliation supprimées");
      }
      
      // Créer une nouvelle demande
      const structure = structures.find(s => s.id === structureId);
      await addDoc(collection(db, 'affiliationRequests'), {
        medecinId: user.uid,
        medecinNom: `${medecinData.prenom} ${medecinData.nom}`,
        structureId: structureId,
        structureName: structure.nom,
        status: 'pending',
        createdAt: new Date(),
        updatedAt: new Date()
      });
      
      setMessage("Demande d'affiliation envoyée avec succès.");
      
      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };
  

  // Fonction pour annuler une demande d'affiliation
  const handleCancelRequest = async (requestId) => {
    try {
      await deleteDoc(doc(db, 'affiliationRequests', requestId));
      
      setMessage("Demande d'affiliation annulée.");
      
      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };


  // Fonction pour vérifier si une demande d'affiliation peut être faite
const canRequestAffiliation = (structureId) => {
  // Vérifier si déjà affilié
  const isAffiliated = affiliatedStructures.some(s => s.id === structureId);
  
  // Vérifier si une demande est en attente
  const hasPendingRequest = sentAffiliationRequests.some(req => 
    req.structureId === structureId && req.status === "pending"
  );
  
  // Vérifier si une demande a été rejetée récemment (moins de 30 jours)
  const hasRecentRejection = rejectedAffiliations.some(req => {
    if (req.structureId !== structureId) return false;
    
    // Vérifier si le rejet date de moins de 30 jours
    const rejectionDate = req.updatedAt?.toDate() || new Date();
    const daysSinceRejection = (new Date() - rejectionDate) / (1000 * 60 * 60 * 24);
    return daysSinceRejection < 30;
  });
  
  // Vérifier l'historique des désaffiliations
  const [wasRecentlyDisaffiliated, setWasRecentlyDisaffiliated] = useState(false);
  
  useEffect(() => {
    const checkDisaffiliationHistory = async () => {
      try {
        const historyQuery = query(
          collection(db, 'affiliationHistory'),
          where("medecinId", "==", auth.currentUser.uid),
          where("structureId", "==", structureId),
          where("action", "==", "removed")
        );
        
        const snapshot = await getDocs(historyQuery);
        let recentDisaffiliation = false;
        
        snapshot.forEach(doc => {
          const data = doc.data();
          const disaffiliationDate = data.timestamp?.toDate() || new Date();
          const daysSinceDisaffiliation = (new Date() - disaffiliationDate) / (1000 * 60 * 60 * 24);
          
          if (daysSinceDisaffiliation < 7) { // Période de "refroidissement" de 7 jours
            recentDisaffiliation = true;
          }
        });
        
        setWasRecentlyDisaffiliated(recentDisaffiliation);
      } catch (error) {
        console.error("Erreur lors de la vérification de l'historique de désaffiliation:", error);
      }
    };
    
    if (structureId) {
      checkDisaffiliationHistory();
    }
  }, [structureId]);
  
  return !isAffiliated && !hasPendingRequest && !hasRecentRejection && !wasRecentlyDisaffiliated;
};



  // Fonction pour annuler une demande d'affiliation
  const handleCancelAffiliation = async (affiliationId) => {
    try {
      await deleteDoc(doc(db, 'affiliationRequests', affiliationId));
      
      setMessage("Demande d'affiliation annulée.");
      
      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };  

// Fonction pour se désaffilier
const handleDesaffiliation = async (structureId) => {
  // Demander confirmation avant de procéder
  if (!window.confirm("Êtes-vous sûr de vouloir vous désaffilier de cette structure ? Vous ne pourrez plus recevoir de rendez-vous de sa part.")) {
    return;
  }
  
  try {
    setLoading(true);
    const user = auth.currentUser;
    
    // Trouver l'affiliation - rechercher avec les deux statuts possibles
    const affiliationsQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", user.uid),
      where("structureId", "==", structureId),
      where("status", "in", ["accepted"])
    );
    
    const querySnapshot = await getDocs(affiliationsQuery);
    if (querySnapshot.empty) {
      setMessage("Affiliation non trouvée.");
      setLoading(false);
      return;
    }
    
    // Supprimer l'affiliation
    const affiliationId = querySnapshot.docs[0].id;
    console.log("Suppression de l'affiliation:", affiliationId);
    await deleteDoc(doc(db, 'affiliationRequests', affiliationId));
    
    // Mettre à jour immédiatement l'UI
    setAffiliatedStructures(prev => prev.filter(s => s.id !== structureId));
    
    setMessage("Désaffiliation effectuée avec succès.");
    
    // Faire disparaître le message après 3 secondes
    setTimeout(() => setMessage(''), 3000);
  } catch (error) {
    console.error("Erreur lors de la désaffiliation:", error);
    setMessage(`Erreur: ${error.message}`);
  } finally {
    setLoading(false);
  }
};


  // Fonctions pour la vue calendrier
  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (year, month) => {
    return new Date(year, month, 1).getDay();
  };

  const getMonthData = useCallback(() => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    
    const daysInMonth = getDaysInMonth(year, month);
    const firstDayOfMonth = getFirstDayOfMonth(year, month);
    
    const days = [];
    
    // Ajouter les jours du mois précédent pour compléter la première semaine
    const prevMonthDays = getDaysInMonth(year, month - 1);
    for (let i = firstDayOfMonth - 1; i >= 0; i--) {
      const date = new Date(year, month - 1, prevMonthDays - i);
      const dateString = formatDateString(date);
      days.push({
        date: date,
        isCurrentMonth: false,
        hasEvents: false,
        events: [],
        dateString: dateString
      });
    }
    
    // Ajouter les jours du mois courant
    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(year, month, i);
      const dateString = formatDateString(date);
      
      // Vérifier les rendez-vous pour cette date
      const dayEvents = rendezvous.filter(rdv => {
        return rdv.date === dateString && 
          (filtreStatut === 'tous' || rdv.statut === filtreStatut) &&
          (filtreStructure === '' || rdv.structureId === filtreStructure);
      });
      
      days.push({
        date: date,
        isCurrentMonth: true,
        hasEvents: dayEvents.length > 0,
        events: dayEvents,
        dateString: dateString
      });
    }
    
    // Ajouter les jours du mois suivant pour compléter la dernière semaine
    const totalDaysToShow = 42; // 6 semaines
    const remainingDays = totalDaysToShow - days.length;
    for (let i = 1; i <= remainingDays; i++) {
      const date = new Date(year, month + 1, i);
      const dateString = formatDateString(date);
      days.push({
        date: date,
        isCurrentMonth: false,
        hasEvents: false,
        events: [],
        dateString: dateString
      });
    }
    
    return days;
  }, [currentMonth, rendezvous, filtreStatut, filtreStructure]);

  const formatDateString = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  };

  const handleDateClick = (day) => {
    if (day.hasEvents) {
      setSelectedDate(day);
      handleViewDetails('date-events', day);
    }
  };
  
  
  const handleMobileDateClick = (day) => {
    if (day.hasEvents) {
      setSelectedDate(day);
      handleViewDetails('date-events', day);
    }
  };
  

  const handleRdvClick = (rdv) => {
    handleViewDetails('rdv', rdv);
  };

  const handlePrevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };

  // Fonction pour obtenir les informations d'une structure par son ID
  const getStructureById = (structureId) => {
    return structures.find(structure => structure.id === structureId) || { nom: 'Structure inconnue' };
  };

  // Fonction pour obtenir les informations d'un patient par son ID
  const getPatientById = (patientId) => {
    return patients.find(patient => patient.id === patientId);
  };

  // Fonction pour afficher les détails d'un patient
  const handleViewPatient = (patientId) => {
    const patient = getPatientById(patientId);
    if (patient) {
      handleViewDetails('patient', patient);
    }
  };

  // Fonction pour calculer l'âge à partir de la date de naissance
  const calculateAge = (dateNaissance) => {
    if (!dateNaissance) return 'N/A';
    
    const birthDate = new Date(dateNaissance);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return age;
  };

  // Filtrer les rendez-vous
  const filteredRendezvous = rendezvous.filter(rdv => {
    let matchesDate = true;
    let matchesStatut = true;
    let matchesStructure = true;
    
    if (filtreDate) {
      matchesDate = rdv.date === filtreDate;
    }
    
    if (filtreStatut !== 'tous') {
      matchesStatut = rdv.statut === filtreStatut;
    }
    
    if (filtreStructure !== '') {
      matchesStructure = rdv.structureId === filtreStructure;
    }
    
    return matchesDate && matchesStatut && matchesStructure;
  });

  // Trier les rendez-vous par date et heure
  filteredRendezvous.sort((a, b) => {
    if (a.date !== b.date) {
      return new Date(a.date) - new Date(b.date);
    }
    return a.heure.localeCompare(b.heure);
  });

  // Interface mobile
  const handleMobileTabChange = (tab) => {
    setActiveTab(tab);
    setShowMobileMenu(false);
    setMobileDetailView(null);
  };

  const handleMobileDetailView = (type, item) => {
    handleViewDetails(type, item);
  };
  

  const handleBackToList = () => {
    setMobileDetailView(null);
  };

  // Fonction pour rafraîchir les affiliations
  const refreshAffiliations = async () => {
    try {
      setLoading(true);
      setMessage("Rafraîchissement des données...");
      
      // Les écouteurs en temps réel mettront automatiquement à jour les données
      // Cette fonction est conservée pour permettre un rafraîchissement manuel si nécessaire
      
      setMessage("Données mises à jour avec succès");
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error("Erreur lors du rafraîchissement des affiliations:", error);
      setMessage(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };


  // Écouteur pour l'historique des désaffiliations
const setupDisaffiliationHistoryListener = (medecinId) => {
  const historyQuery = query(
    collection(db, 'affiliationHistory'),
    where("medecinId", "==", medecinId),
    where("action", "==", "removed")
  );
  
  return onSnapshot(historyQuery, (snapshot) => {
    try {
      const history = [];
      snapshot.forEach((doc) => {
        history.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      setDisaffiliationHistory(history);
    } catch (error) {
      console.error("Erreur lors de la récupération de l'historique des désaffiliations:", error);
    }
  }, (error) => {
    console.error("Erreur d'écoute de l'historique des désaffiliations:", error);
  });
};

// Fonction pour vérifier si une structure a récemment désaffilié le médecin
const wasRecentlyDisaffiliated = (structureId) => {
  return disaffiliationHistory.some(history => {
    if (history.structureId !== structureId) return false;
    
    // Vérifier si la désaffiliation date de moins de 7 jours
    const disaffiliationDate = history.timestamp?.toDate() || new Date();
    const daysSinceDisaffiliation = (new Date() - disaffiliationDate) / (1000 * 60 * 60 * 24);
    return daysSinceDisaffiliation < 1; // Période de "refroidissement" de 1 jour
  });
};

// Fonction pour nettoyer les demandes d'affiliation obsolètes
const cleanupAffiliationRequests = async () => {
  try {
    const user = auth.currentUser;
    if (!user) return;
    
    // Récupérer toutes les demandes d'affiliation pour ce médecin
    const affiliationsQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", user.uid)
    );
    
    const querySnapshot = await getDocs(affiliationsQuery);
    
    // Vérifier chaque demande
    for (const docSnap of querySnapshot.docs) {
      const request = docSnap.data();
      
      // Si la structure est dans la liste des structures affiliées,
      // mais que la demande n'est pas "accepted", la supprimer
      const isAffiliated = affiliatedStructures.some(s => s.id === request.structureId);
      if (isAffiliated && request.status !== "accepted") {
        await deleteDoc(docSnap.ref);
        console.log(`Demande obsolète supprimée: ${docSnap.id}`);
      }
      
      // Si la structure n'est pas dans la liste des structures affiliées,
      // mais que la demande est "accepted", la supprimer également
      if (!isAffiliated && request.status === "accepted") {
        await deleteDoc(docSnap.ref);
        console.log(`Demande approuvée obsolète supprimée: ${docSnap.id}`);
      }
    }
    
    console.log("Nettoyage des demandes d'affiliation terminé");
  } catch (error) {
    console.error("Erreur lors du nettoyage des demandes d'affiliation:", error);
  }
};





const handleViewDetails = (type, item) => {
  setDetailsType(type);
  setDetailsItem(item);
  setShowDetails(true);
  
  // Cas spécifiques selon le type
  if (type === 'archive') {
    setArchiveNotes(item.notes || '');
    setArchiveFiles(item.files || []);
  } else if (type === 'rdv') {
    setSelectedRdv(item);
    setNewStatus(item.statut);
  } else if (type === 'patient') {
    setSelectedPatient(item);
  }
};


const startEditStatus = (rdv) => {
  setSelectedRdv(rdv);
  setNewStatus(rdv.statut);
  setEditingStatus(true);
};

// Fonction pour enregistrer le nouveau statut
const saveStatusChange = async () => {
  try {
    if (!selectedRdv) return;
    
    // Mettre à jour dans Firestore
    await updateDoc(doc(db, 'rendezvous', selectedRdv.id), {
      statut: newStatus,
      updatedAt: new Date()
    });
    
    // Mettre à jour l'UI localement
    setRendezvous(prev => prev.map(rdv => 
      rdv.id === selectedRdv.id ? {...rdv, statut: newStatus} : rdv
    ));
    
    setMessage('Statut du rendez-vous mis à jour avec succès');
    setTimeout(() => setMessage(''), 3000);
    
    // Réinitialiser l'état d'édition
    setEditingStatus(false);
    
    // Fermer la modal si ouverte
    const rdvModal = document.getElementById('rdvDetailsModal');
    if (rdvModal) {
      const bsModal = window.bootstrap.Modal.getInstance(rdvModal);
      if (bsModal) bsModal.hide();
    }
  } catch (error) {
    console.error("Erreur lors de la mise à jour du statut:", error);
    setMessage(`Erreur: ${error.message}`);
  }
};

// Fonction pour annuler l'édition
const cancelEditStatus = () => {
  setEditingStatus(false);
};

// Fonction pour vérifier les affiliations
const checkAffiliations = async () => {
  try {
    const user = auth.currentUser;
    if (!user) return;
    
    // Vérifier les affiliations approuvées
    const approvedQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", user.uid),
      where("status", "==", "approved") // Vérifier avec "approved"
    );
    
    const approvedSnapshot = await getDocs(approvedQuery);
    console.log(`Affiliations approuvées trouvées: ${approvedSnapshot.size}`);
    
    // Vérifier aussi avec "accepted" au cas où
    const acceptedQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", user.uid),
      where("status", "==", "accepted") // Vérifier avec "accepted"
    );
    
    const acceptedSnapshot = await getDocs(acceptedQuery);
    console.log(`Affiliations acceptées trouvées: ${acceptedSnapshot.size}`);
    
    // Afficher les détails pour débogage
    approvedSnapshot.forEach(doc => {
      console.log("Affiliation approuvée:", doc.id, doc.data());
    });
    
    acceptedSnapshot.forEach(doc => {
      console.log("Affiliation acceptée:", doc.id, doc.data());
    });
  } catch (error) {
    console.error("Erreur lors de la vérification des affiliations:", error);
  }
};





  // Vérification de l'authentification et configuration des écouteurs
  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          setLoading(true);
          const docRef = doc(db, 'medecins', user.uid);
          const docSnap = await getDoc(docRef);
          
          if (docSnap.exists()) {
            const data = docSnap.data();
            setMedecinData(data);
            setForm(data);
            
            console.log("Chargement des données du médecin:", user.uid);
            
            // Configurer les écouteurs
            const unsubscribeAllStructures = setupAllStructuresListener();
            console.log("Écouteur pour toutes les structures configuré");
            
            const unsubscribeRejectedAffiliations = setupRejectedAffiliationsListener(user.uid);
            console.log("Écouteur pour les affiliations rejetées configuré");
            
            const unsubscribePendingAffiliations = setupPendingAffiliationsListener(user.uid);
            console.log("Écouteur pour les affiliations en attente configuré");
            
            const unsubscribeAffiliatedStructures = setupAffiliatedStructuresListener(user.uid);
            console.log("Écouteur pour les structures affiliées configuré");
            
            const unsubscribeRendezvous = setupRendezvousListener(user.uid);
            console.log("Écouteur pour les rendez-vous configuré");
            
            const unsubscribeSentRequests = setupSentAffiliationRequestsListener(user.uid);
            console.log("Écouteur pour les demandes d'affiliation envoyées configuré");
            const unsubscribeArchives = setupArchivesListener(user.uid);
            console.log("Écouteur pour les archives configuré");
            
            // Stocker les fonctions de désabonnement
            setUnsubscribeFunctions([
              unsubscribeAllStructures,
              unsubscribeRejectedAffiliations,
              unsubscribePendingAffiliations,
              unsubscribeAffiliatedStructures,
              unsubscribeRendezvous,
              unsubscribeSentRequests,
              unsubscribeArchives,

            ]);
          } else {
            console.error("Aucun document médecin trouvé!");
            navigate('/auth');
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des données:", error);
        } finally {
          setLoading(false);
        }
      } else {
        navigate('/auth');
      }
    });
    
    // Nettoyage lors du démontage du composant
    return () => {
      unsubscribeAuth();
      // Désabonner tous les écouteurs
      unsubscribeFunctions.forEach(unsubscribe => {
        if (typeof unsubscribe === 'function') {
          unsubscribe();
        }
      });
    };
  }, [auth, navigate]);

// Fonction pour changer le statut d'un rendez-vous
const handleChangeRdvStatus = async (rdvId, newStatus) => {
  try {
    // Récupérer le rendez-vous actuel
    const rdvDoc = await getDoc(doc(db, 'rendezvous', rdvId));
    if (!rdvDoc.exists()) {
      setMessage('Rendez-vous non trouvé');
      return;
    }
    
    const rdvData = {
      id: rdvId,
      ...rdvDoc.data()
    };
    
    // Mettre à jour dans Firestore
    await updateDoc(doc(db, 'rendezvous', rdvId), {
      statut: newStatus,
      updatedAt: new Date()
    });
    
    // Mettre à jour l'UI localement
    setRendezvous(prev => prev.map(rdv => 
      rdv.id === rdvId ? {...rdv, statut: newStatus} : rdv
    ));
    
    // Mettre à jour également dans selectedDate si nécessaire
    if (selectedDate) {
      const updatedEvents = selectedDate.events.map(rdv => 
        rdv.id === rdvId ? {...rdv, statut: newStatus} : rdv
      );
      setSelectedDate({...selectedDate, events: updatedEvents});
    }
    
    // Si le statut est "confimé", archiver automatiquement le patient
    if (newStatus === 'confimé') {
      const updatedRdv = {
        ...rdvData,
        statut: newStatus
      };
      await archivePatientWhenRdvCompleted(updatedRdv);
    }
    
    setMessage('Statut du rendez-vous mis à jour avec succès');
    setTimeout(() => setMessage(''), 3000);
  } catch (error) {
    console.error("Erreur lors de la mise à jour du statut:", error);
    setMessage(`Erreur: ${error.message}`);
  }
};



// Fonction pour récupérer les archives
const setupArchivesListener = (medecinId) => {
  const archivesQuery = query(
    collection(db, 'archives'),
    where("medecinId", "==", medecinId)
  );
  
  return onSnapshot(archivesQuery, (snapshot) => {
    try {
      const archivesData = [];
      snapshot.forEach((doc) => {
        archivesData.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      setArchives(archivesData);
    } catch (error) {
      console.error("Erreur lors de la récupération des archives:", error);
    }
  }, (error) => {
    console.error("Erreur d'écoute des archives:", error);
  });
};

// Fonction pour archiver automatiquement un patient après un rendez-vous
const archivePatientAfterRdv = async (rdv, patient) => {
  try {
    if (!rdv || !patient) return;
    
    const user = auth.currentUser;
    if (!user) return;
    
    // Vérifier si une archive existe déjà pour ce patient
    const archiveQuery = query(
      collection(db, 'archives'),
      where("medecinId", "==", user.uid),
      where("patientId", "==", patient.id)
    );
    
    const archiveSnapshot = await getDocs(archiveQuery);
    
    if (archiveSnapshot.empty) {
      // Créer une nouvelle archive
      const structureDoc = await getDoc(doc(db, 'structures', rdv.structureId));
      const structureName = structureDoc.exists() ? structureDoc.data().nom : 'Structure inconnue';
      
      await addDoc(collection(db, 'archives'), {
        medecinId: user.uid,
        patientId: patient.id,
        patient: patient,
        rendezVous: [{
          ...rdv,
          structureName: structureName
        }],
        notes: '',
        files: [],
        createdAt: new Date(),
        updatedAt: new Date(),
        lastVisit: new Date(rdv.date)
      });
      
      console.log("Nouvelle archive créée pour le patient:", patient.id);
    } else {
      // Mettre à jour l'archive existante
      const archiveId = archiveSnapshot.docs[0].id;
      const archiveData = archiveSnapshot.docs[0].data();
      
      const structureDoc = await getDoc(doc(db, 'structures', rdv.structureId));
      const structureName = structureDoc.exists() ? structureDoc.data().nom : 'Structure inconnue';
      
      // Vérifier si le rendez-vous existe déjà dans l'archive
      const rdvExists = archiveData.rendezVous.some(existingRdv => existingRdv.id === rdv.id);
      
      if (!rdvExists) {
        // Ajouter le nouveau rendez-vous à l'archive
        await updateDoc(doc(db, 'archives', archiveId), {
          rendezVous: arrayUnion({
            ...rdv,
            structureName: structureName
          }),
          updatedAt: new Date(),
          lastVisit: new Date(rdv.date) > new Date(archiveData.lastVisit) ? new Date(rdv.date) : archiveData.lastVisit
        });
        
        console.log("Archive mise à jour pour le patient:", patient.id);
      }
    }
  } catch (error) {
    console.error("Erreur lors de l'archivage du patient:", error);
  }
};

// Fonction pour voir une archive
const handleViewArchive = (archive) => {
  handleViewDetails('archive', archive);
};

// Fonction pour sauvegarder les notes d'une archive
const handleSaveArchiveNotes = async () => {
  try {
    if (!selectedArchive) return;
    
    await updateDoc(doc(db, 'archives', selectedArchive.id), {
      notes: archiveNotes,
      updatedAt: new Date()
    });
    
    // Mettre à jour l'UI
    setArchives(prev => prev.map(archive => 
      archive.id === selectedArchive.id ? {...archive, notes: archiveNotes} : archive
    ));
    
    setMessage('Notes enregistrées avec succès');
    setTimeout(() => setMessage(''), 3000);
  } catch (error) {
    console.error("Erreur lors de l'enregistrement des notes:", error);
    setMessage(`Erreur: ${error.message}`);
  }
};

// Fonction pour gérer le changement de fichier
const handleArchiveFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  
  // Stocker le fichier sélectionné temporairement
  setArchiveFiles(prev => [...prev, {
    file: file,
    name: file.name,
    type: file.type,
    size: file.size,
    uploadDate: new Date(),
    isNew: true
  }]);
};

// Fonction pour téléverser un fichier
const handleArchiveFileUpload = async () => {
  try {
    if (!selectedArchive) return;
    
    // Trouver les nouveaux fichiers à téléverser
    const newFiles = archiveFiles.filter(file => file.isNew);
    if (newFiles.length === 0) {
      setMessage('Aucun nouveau fichier à téléverser');
      return;
    }
    
    setLoading(true);
    
    // Pour chaque nouveau fichier
    for (const fileObj of newFiles) {
      // Générer un ID unique pour le fichier
      const fileId = `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
      
      // Créer une référence dans Firebase Storage
      const storageRef = ref(storage, `archives/${selectedArchive.id}/${fileId}-${fileObj.name}`);
      
      // Téléverser le fichier
      await uploadBytes(storageRef, fileObj.file);
      
      // Obtenir l'URL de téléchargement
      const downloadURL = await getDownloadURL(storageRef);
      
      // Ajouter le fichier à l'archive dans Firestore
      await updateDoc(doc(db, 'archives', selectedArchive.id), {
        files: arrayUnion({
          id: fileId,
          name: fileObj.name,
          type: fileObj.type,
          size: fileObj.size,
          uploadDate: new Date(),
          url: downloadURL
        }),
        updatedAt: new Date()
      });
    }
    
    // Mettre à jour l'UI
    const updatedArchiveRef = await getDoc(doc(db, 'archives', selectedArchive.id));
    if (updatedArchiveRef.exists()) {
      const updatedArchive = {
        id: selectedArchive.id,
        ...updatedArchiveRef.data()
      };
      
      setSelectedArchive(updatedArchive);
      setArchiveFiles(updatedArchive.files || []);
      
      // Mettre à jour la liste des archives
      setArchives(prev => prev.map(archive => 
        archive.id === selectedArchive.id ? updatedArchive : archive
      ));
    }
    
    setMessage('Fichier(s) téléversé(s) avec succès');
    setTimeout(() => setMessage(''), 3000);
  } catch (error) {
    console.error("Erreur lors du téléversement du fichier:", error);
    setMessage(`Erreur: ${error.message}`);
  } finally {
    setLoading(false);
  }
};

// Fonction pour télécharger un fichier
const handleDownloadArchiveFile = (file) => {
  if (!file.url) {
    setMessage('URL de téléchargement non disponible');
    return;
  }
  
  // Créer un lien temporaire pour le téléchargement
  const link = document.createElement('a');
  link.href = file.url;
  link.target = '_blank';
  link.download = file.name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Fonction pour supprimer un fichier (suite)
const handleDeleteArchiveFile = async (fileId) => {
  try {
    if (!selectedArchive || !fileId) return;
    
    // Demander confirmation
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce fichier ?")) {
      return;
    }
    
    // Trouver le fichier à supprimer
    const fileToDelete = selectedArchive.files.find(file => file.id === fileId);
    if (!fileToDelete) return;
    
    // Supprimer le fichier du stockage si une URL est disponible
    if (fileToDelete.url) {
      const fileRef = ref(storage, fileToDelete.url);
      await deleteObject(fileRef);
    }
    
    // Mettre à jour l'archive dans Firestore
    const updatedFiles = selectedArchive.files.filter(file => file.id !== fileId);
    await updateDoc(doc(db, 'archives', selectedArchive.id), {
      files: updatedFiles,
      updatedAt: new Date()
    });
    
    // Mettre à jour l'UI
    setSelectedArchive({...selectedArchive, files: updatedFiles});
    setArchiveFiles(updatedFiles);
    
    // Mettre à jour la liste des archives
    setArchives(prev => prev.map(archive => 
      archive.id === selectedArchive.id ? {...archive, files: updatedFiles} : archive
    ));
    
    setMessage('Fichier supprimé avec succès');
    setTimeout(() => setMessage(''), 3000);
  } catch (error) {
    console.error("Erreur lors de la suppression du fichier:", error);
    setMessage(`Erreur: ${error.message}`);
  }
};

// Fonction pour supprimer une archive
const handleDeleteArchive = async (archiveId) => {
  try {
    if (!archiveId) return;
    
    // Demander confirmation
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer définitivement cette archive ? Cette action est irréversible.")) {
      return;
    }
    
    setLoading(true);
    
    // Récupérer l'archive pour obtenir les fichiers associés
    const archiveDoc = await getDoc(doc(db, 'archives', archiveId));
    if (archiveDoc.exists()) {
      const archiveData = archiveDoc.data();
      
      // Supprimer tous les fichiers associés du stockage
      if (archiveData.files && archiveData.files.length > 0) {
        for (const file of archiveData.files) {
          if (file.url) {
            try {
              const fileRef = ref(storage, file.url);
              await deleteObject(fileRef);
            } catch (fileError) {
              console.error("Erreur lors de la suppression du fichier:", fileError);
            }
          }
        }
      }
    }
    
    // Supprimer l'archive de Firestore
    await deleteDoc(doc(db, 'archives', archiveId));
    
    // Mettre à jour l'UI
    setArchives(prev => prev.filter(archive => archive.id !== archiveId));
    
    // Fermer la modal si ouverte
    const archiveModal = document.getElementById('archiveModal');
    if (archiveModal) {
      const bsModal = bootstrap.Modal.getInstance(archiveModal);
      if (bsModal) bsModal.hide();
    }
    
    setMessage('Archive supprimée avec succès');
    setTimeout(() => setMessage(''), 3000);
  } catch (error) {
    console.error("Erreur lors de la suppression de l'archive:", error);
    setMessage(`Erreur: ${error.message}`);
  } finally {
    setLoading(false);
  }
};

// Fonction pour archiver automatiquement un patient lorsqu'un rendez-vous est terminé
const archivePatientWhenRdvCompleted = async (rdv) => {
  try {
    // Vérifier si le rendez-vous est terminé
    if (rdv.statut !== 'terminé') return;
    
    // Récupérer les informations du patient
    if (!rdv.patientId) return;
    
    const patientDoc = await getDoc(doc(db, 'patients', rdv.patientId));
    if (!patientDoc.exists()) return;
    
    const patient = {
      id: rdv.patientId,
      ...patientDoc.data()
    };
    
    // Archiver le patient
    await archivePatientAfterRdv(rdv, patient);
  } catch (error) {
    console.error("Erreur lors de l'archivage automatique:", error);
  }
};


// Fonction pour archiver manuellement un patient
const handleManualArchivePatient = async (patient) => {
  try {
    // Vérifier si une archive existe déjà pour ce patient
    const user = auth.currentUser;
    if (!user) return;
    
    const archiveQuery = query(
      collection(db, 'archives'),
      where("medecinId", "==", user.uid),
      where("patientId", "==", patient.id)
    );
    
    const archiveSnapshot = await getDocs(archiveQuery);
    
    if (archiveSnapshot.empty) {
      // Créer une nouvelle archive
      // Récupérer les rendez-vous du patient
      const rdvQuery = query(
        collection(db, 'rendezvous'),
        where("medecinId", "==", user.uid),
        where("patientId", "==", patient.id)
      );
      
      const rdvSnapshot = await getDocs(rdvQuery);
      const patientRdvs = [];
      
      // Pour chaque rendez-vous, récupérer le nom de la structure
      for (const rdvDoc of rdvSnapshot.docs) {
        const rdvData = {
          id: rdvDoc.id,
          ...rdvDoc.data()
        };
        
        const structureDoc = await getDoc(doc(db, 'structures', rdvData.structureId));
        const structureName = structureDoc.exists() ? structureDoc.data().nom : 'Structure inconnue';
        
        patientRdvs.push({
          ...rdvData,
          structureName: structureName
        });
      }
      
      // Déterminer la date de la dernière visite
      let lastVisit = new Date();
      if (patientRdvs.length > 0) {
        // Trier les rendez-vous par date décroissante
        patientRdvs.sort((a, b) => new Date(b.date) - new Date(a.date));
        lastVisit = new Date(patientRdvs[0].date);
      }
      
      // Créer l'archive
      await addDoc(collection(db, 'archives'), {
        medecinId: user.uid,
        patientId: patient.id,
        patient: patient,
        rendezVous: patientRdvs,
        notes: '',
        files: [],
        createdAt: new Date(),
        updatedAt: new Date(),
        lastVisit: lastVisit,
        rdvCount: patientRdvs.length
      });
      
      setMessage(`Patient ${patient.prenom} ${patient.nom} archivé avec succès`);
    } else {
      setMessage(`Ce patient est déjà archivé`);
    }
    
    setTimeout(() => setMessage(''), 3000);
  } catch (error) {
    console.error("Erreur lors de l'archivage manuel du patient:", error);
    setMessage(`Erreur: ${error.message}`);
  }
};






const DetailView = ({ 
  showDetails, 
  detailsType, 
  detailsItem, 
  setShowDetails, 
  isMobile, 
  // Archives
  archiveNotes, 
  setArchiveNotes, 
  archiveFiles, 
  // Rdv
  editingStatus, 
  newStatus, 
  setNewStatus, 
  // Functions
  calculateAge, 
  getStructureById, 
  getPatientById, 
  handleSaveArchiveNotes, 
  handleArchiveFileChange, 
  handleArchiveFileUpload, 
  handleDownloadArchiveFile, 
  handleDeleteArchiveFile, 
  handleDeleteArchive, 
  startEditStatus, 
  saveStatusChange, 
  cancelEditStatus 
}) => {
  if (!showDetails || !detailsItem) return null;
  
  // Style pour l'overlay modal
  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: isMobile ? 'start' : 'center',
    overflowY: 'auto',
    padding: isMobile ? '10px' : '30px'
  };
  
  // Style pour le contenu modal avec fond bleu
  const contentStyle = {
    backgroundColor: '#f0f8ff', // Fond bleu clair
    borderRadius: '12px',
    padding: '25px',
    maxWidth: isMobile ? '100%' : '800px',
    width: isMobile ? '95%' : '80%',
    maxHeight: isMobile ? '90vh' : '80vh',
    overflowY: 'auto',
    marginTop: isMobile ? '60px' : '0',
    boxShadow: '0 5px 25px rgba(0, 0, 0, 0.2)',
    border: '1px solid #e0f0ff'
  };
  
  // Style pour les cartes
  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '20px',
    marginBottom: '15px',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)'
  };
  
  // Style pour les onglets
  const tabStyle = {
    border: 'none',
    backgroundColor: 'transparent',
    padding: '10px 15px',
    fontWeight: '500',
    color: '#4a6fa5',
    borderBottom: '2px solid transparent',
    transition: 'all 0.3s ease'
  };
  
  const activeTabStyle = {
    ...tabStyle,
    borderBottom: '2px solid #2c7be5',
    color: '#2c7be5'
  };
  
  // Gérer le clic sur un onglet d'archive
  const handleArchiveTabClick = (tabId) => {
    document.querySelectorAll('.tab-pane').forEach(el => el.classList.remove('active'));
    document.getElementById(tabId).classList.add('active');
    document.querySelectorAll('.archive-tab').forEach(el => {
      el.style.borderBottom = '2px solid transparent';
      el.style.color = '#4a6fa5';
    });
    document.getElementById(`${tabId}-tab`).style.borderBottom = '2px solid #2c7be5';
    document.getElementById(`${tabId}-tab`).style.color = '#2c7be5';
  };
  
  // Contenu selon le type
  let content;
  
  switch(detailsType) {
    case 'patient':
      content = (
        <div style={cardStyle}>
          <h4 className="mb-4">{detailsItem.prenom} {detailsItem.nom}</h4>
          <div className="patient-details">
            <div className="row mb-2">
              <div className="col-md-6">
                <p><strong>Date de naissance:</strong> {new Date(detailsItem.dateNaissance).toLocaleDateString()}</p>
                <p><strong>Âge:</strong> {calculateAge(detailsItem.dateNaissance)} ans</p>
                <p><strong>Sexe:</strong> {detailsItem.sexe || 'Non spécifié'}</p>
              </div>
              <div className="col-md-6">
                <p><strong>Téléphone:</strong> {detailsItem.telephone || 'Non spécifié'}</p>
                <p><strong>Email:</strong> {detailsItem.email || 'Non spécifié'}</p>
                <p><strong>Adresse:</strong> {detailsItem.adresse || 'Non spécifiée'}</p>
              </div>
            </div>
            
            {detailsItem.assurances && detailsItem.assurances.length > 0 && (
              <div className="mb-3 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
                <strong>Assurances:</strong> 
                <div className="mt-2">
                  {detailsItem.assurances.map((assurance, index) => (
                    <span key={index} className="badge bg-white text-primary me-2 mb-1 py-2 px-3" style={{borderRadius: '20px'}}>
                      {assurance}
                    </span>
                  ))}
                </div>
              </div>
            )}
            
            {detailsItem.antecedentsMedicaux && (
              <div className="mt-3 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
                <strong>Antécédents médicaux:</strong>
                <p className="text-muted mt-2 mb-0">{detailsItem.antecedentsMedicaux}</p>
              </div>
            )}
            {detailsItem.diagnostics && (
              <div className="mt-3 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
                <strong>Diagnostic:</strong>
                <p className="text-muted mt-2 mb-0">{detailsItem.diagnostics}</p>
              </div>
            )}
          </div>
        </div>
      );
      break;
      
    case 'rdv':
      content = (
        <div style={cardStyle}>
          <h4 className="mb-4">Détails du rendez-vous</h4>
          <div className="row mb-3">
            <div className="col-md-6">
              <p><strong>Patient:</strong> {detailsItem.patientNom || 'Non spécifié'}</p>
              <p><strong>Structure:</strong> {getStructureById(detailsItem.structureId).nom}</p>
              <p><strong>Motif:</strong> {detailsItem.motif || 'Non spécifié'}</p>
            </div>
            <div className="col-md-6">
              <p><strong>Date:</strong> {new Date(detailsItem.date).toLocaleDateString()}</p>
              <p><strong>Heure:</strong> {detailsItem.heure}</p>
            </div>
          </div>
          
          <div className="mt-4 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
            <strong>Statut:</strong>
            {editingStatus ? (
              <div className="mt-2">
                <select 
                  className="form-select mb-2" 
                  value={newStatus}
                  onChange={(e) => setNewStatus(e.target.value)}
                  style={{borderRadius: '6px'}}
                >
                  <option value="confirmé">Confirmé</option>
                  <option value="terminé">Terminé</option>
                  <option value="annulé">Annulé</option>
                </select>
                <div className="d-flex gap-2 mt-2">
                  <button className="btn btn-sm btn-success" onClick={saveStatusChange} style={{borderRadius: '6px'}}>
                    <FontAwesomeIcon icon={faCheck} className="me-1" />
                    Enregistrer
                  </button>
                  <button className="btn btn-sm btn-secondary" onClick={cancelEditStatus} style={{borderRadius: '6px'}}>
                    <FontAwesomeIcon icon={faTimes} className="me-1" />
                    Annuler
                  </button>
                </div>
              </div>
            ) : (
              <div className="d-flex align-items-center mt-2">
                <span className={`badge status-badge-${detailsItem.statut} me-2 py-2 px-3`} style={{borderRadius: '20px'}}>
                  {detailsItem.statut.charAt(0).toUpperCase() + detailsItem.statut.slice(1)}
                </span>
                <button 
                  className="btn btn-sm btn-outline-primary" 
                  onClick={() => startEditStatus(detailsItem)}
                  style={{borderRadius: '6px'}}
                >
                  <FontAwesomeIcon icon={faEdit} className="me-1" />
                  Modifier
                </button>
              </div>
            )}
          </div>
          
          {detailsItem.patientId && (
            <div className="mt-4">
              <button 
                className="btn btn-outline-primary"
                onClick={() => {
                  const patient = getPatientById(detailsItem.patientId);
                  if (patient) {
                    setShowDetails(false);
                    // Utiliser un setTimeout pour s'assurer que la première modal est fermée
                    setTimeout(() => {
                      const event = new CustomEvent('viewPatient', { detail: patient });
                      document.dispatchEvent(event);
                    }, 100);
                  }
                }}
                style={{borderRadius: '6px'}}
              >
                <FontAwesomeIcon icon={faUser} className="me-1" />
                Voir le patient
              </button>
            </div>
          )}
          {detailsItem.patientId && (
            <div className="mt-4 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
              <strong>Diagnostic du patient:</strong>
              <p className="text-muted mt-2 mb-0">
                {getPatientById(detailsItem.patientId)?.diagnostics || 'Non spécifié'}
              </p>
            </div>
          )}
        </div>
      );
      break;
      
    case 'archive':
      content = (
        <div style={cardStyle}>
          <h4 className="mb-3">Archive de {detailsItem.patient.prenom} {detailsItem.patient.nom}</h4>
          
          <div className="d-flex mb-3 border-bottom">
            <button 
              className="archive-tab" 
              id="archive-patient-tab" 
              onClick={() => handleArchiveTabClick('archive-patient')}
              style={activeTabStyle}
            >
              Patient
            </button>
            <button 
              className="archive-tab" 
              id="archive-rdv-tab"
              onClick={() => handleArchiveTabClick('archive-rdv')}
              style={tabStyle}
            >
              Rendez-vous
            </button>
            <button 
              className="archive-tab" 
              id="archive-notes-tab"
              onClick={() => handleArchiveTabClick('archive-notes')}
              style={tabStyle}
            >
              Notes
            </button>
            <button 
              className="archive-tab" 
              id="archive-files-tab"
              onClick={() => handleArchiveTabClick('archive-files')}
              style={tabStyle}
            >
              Fichiers
            </button>
          </div>
          
          <div className="tab-content">
            <div id="archive-patient" className="tab-pane active">
              <div className="row">
                <div className="col-md-6">
                  <p><strong>Nom:</strong> {detailsItem.patient.nom}</p>
                  <p><strong>Prénom:</strong> {detailsItem.patient.prenom}</p>
                  <p><strong>Date de naissance:</strong> {new Date(detailsItem.patient.dateNaissance).toLocaleDateString()}</p>
                </div>
                <div className="col-md-6">
                  <p><strong>Téléphone:</strong> {detailsItem.patient.telephone || 'Non spécifié'}</p>
                  <p><strong>Email:</strong> {detailsItem.patient.email || 'Non spécifié'}</p>
                </div>
              </div>
              <div className="mb-2">
                <strong>Diagnostic actuel:</strong>
                <p className="text-muted">
                  {detailsItem.patient.diagnostics || 'Aucun diagnostic enregistré'}
                </p>
              </div>
            </div>
            
            <div id="archive-rdv" className="tab-pane">
              <h5 className="mb-3">Historique des rendez-vous</h5>
              {detailsItem.rendezVous && detailsItem.rendezVous.length > 0 ? (
                <div className="table-responsive">
                  <table className="table" style={{borderCollapse: 'separate', borderSpacing: '0 8px'}}>
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Heure</th>
                        <th>Structure</th>
                        <th>Statut</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailsItem.rendezVous.map((rdv, index) => (
                        <tr key={index} style={{backgroundColor: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.05)'}}>
                          <td className="py-3">{new Date(rdv.date).toLocaleDateString()}</td>
                          <td className="py-3">{rdv.heure}</td>
                          <td className="py-3">{rdv.structureName}</td>
                          <td className="py-3">
                            <span className={`badge status-badge-${rdv.statut} py-2 px-3`} style={{borderRadius: '20px'}}>
                              {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center p-4 text-muted" style={{backgroundColor: 'white', borderRadius: '8px'}}>
                  Aucun rendez-vous enregistré
                </div>
              )}
            </div>
            
            <div id="archive-notes" className="tab-pane">
              <h5 className="mb-3">Notes</h5>
              <textarea 
                className="form-control" 
                rows="6"
                value={archiveNotes}
                onChange={(e) => setArchiveNotes(e.target.value)}
                placeholder="Ajoutez vos notes concernant ce patient ici..."
                style={{borderRadius: '8px', boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)'}}
              ></textarea>
              <div className="mt-3 text-end">
                <button 
                  className="btn btn-primary"
                  onClick={handleSaveArchiveNotes}
                  style={{borderRadius: '6px'}}
                >
                  <FontAwesomeIcon icon={faSave} className="me-1" />
                  Enregistrer les notes
                </button>
              </div>
            </div>
            
            <div id="archive-files" className="tab-pane">
              <h5 className="mb-3">Fichiers</h5>
              <div className="mb-4 p-3" style={{backgroundColor: 'white', borderRadius: '8px', border: '1px dashed #cce5ff'}}>
                <input 
                  type="file" 
                  className="form-control mb-2" 
                  onChange={handleArchiveFileChange}
                  style={{borderRadius: '6px'}}
                />
                <button 
                  className="btn btn-primary w-100" 
                  onClick={handleArchiveFileUpload}
                  style={{borderRadius: '6px'}}
                >
                  <FontAwesomeIcon icon={faFileUpload} className="me-1" />
                  Téléverser
                </button>
              </div>
              
              <div className="file-list">
                {archiveFiles && archiveFiles.length > 0 ? (
                  archiveFiles.map((file, index) => (
                    <div key={index} className="file-item d-flex justify-content-between align-items-center p-3 mb-2" 
                      style={{backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)'}}>
                      <div>
                        <FontAwesomeIcon icon={faFileAlt} className="me-2 text-primary" />
                        {file.name}
                      </div>
                      <div>
                        <button 
                          className="btn btn-sm btn-outline-primary me-1"
                          onClick={() => handleDownloadArchiveFile(file)}
                          style={{borderRadius: '6px'}}
                        >
                          <FontAwesomeIcon icon={faFileDownload} />
                        </button>
                        <button 
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDeleteArchiveFile(file.id)}
                          style={{borderRadius: '6px'}}
                        >
                          <FontAwesomeIcon icon={faTrashAlt} />
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center p-4 text-muted" style={{backgroundColor: 'white', borderRadius: '8px'}}>
                    Aucun fichier disponible
                  </div>
                )}
              </div>
              
              <div className="mt-4 pt-3 border-top">
                <button 
                  className="btn btn-danger"
                  onClick={() => {
                    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette archive ?")) {
                      handleDeleteArchive(detailsItem.id);
                      setShowDetails(false);
                    }
                  }}
                  style={{borderRadius: '6px'}}
                >
                  <FontAwesomeIcon icon={faTrashAlt} className="me-1" />
                  Supprimer cette archive
                </button>
              </div>
            </div>
          </div>
        </div>
      );
      break;
      
    case 'date-events':
      content = (
        <div style={cardStyle}>
          <h4 className="mb-4">Rendez-vous du {detailsItem.date.toLocaleDateString()}</h4>
          {detailsItem.events.length > 0 ? (
            detailsItem.events.map(rdv => (
              <div key={rdv.id} className="mb-3 p-3" style={{backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.1)', borderLeft: `4px solid ${
                rdv.statut === 'confirmé' ? '#2c7be5' :
                rdv.statut === 'terminé' ? '#00d97e' :
                rdv.statut === 'annulé' ? '#e63757' : '#95aac9'
              }`}}>
                <div className="d-flex justify-content-between">
                  <h5 className="mb-1">{rdv.heure} - {rdv.patientNom || 'Patient non spécifié'}</h5>
                  <span className={`badge status-badge-${rdv.statut} py-2 px-3`} style={{borderRadius: '20px'}}>
                    {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                  </span>
                </div>
                <p className="mb-1">{getStructureById(rdv.structureId).nom}</p>
                {rdv.motif && <p className="text-muted mb-2">{rdv.motif}</p>}
                
                <div className="d-flex gap-2 mt-2">
                  <button 
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => {
                      setShowDetails(false);
                      setTimeout(() => {
                        const event = new CustomEvent('viewRdv', { detail: rdv });
                        document.dispatchEvent(event);
                      }, 100);
                    }}
                    style={{borderRadius: '6px'}}
                  >
                    Détails
                  </button>
                  {rdv.patientId && (
                    <button 
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => {
                        const patient = getPatientById(rdv.patientId);
                        if (patient) {
                          setShowDetails(false);
                          setTimeout(() => {
                            const event = new CustomEvent('viewPatient', { detail: patient });
                            document.dispatchEvent(event);
                          }, 100);
                        }
                      }}
                      style={{borderRadius: '6px'}}
                    >
                      Voir patient
                    </button>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="text-center p-4 text-muted" style={{backgroundColor: 'white', borderRadius: '8px'}}>
              Aucun rendez-vous pour cette date
            </div>
          )}
        </div>
      );
      break;
      
    default:
      content = <p>Détails non disponibles</p>;
  }
  
  return (
    <div style={modalStyle} onClick={() => setShowDetails(false)}>
      <div 
        style={contentStyle} 
        onClick={e => e.stopPropagation()}
      >
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="mb-0" style={{color: '#2c7be5'}}>{
            detailsType === 'patient' ? 'Détails du patient' :
            detailsType === 'rdv' ? 'Détails du rendez-vous' :
            detailsType === 'archive' ? `Archive patient` : 
            'Détails'
          }</h3>
          <button 
            className="btn-close" 
            onClick={() => setShowDetails(false)}
            aria-label="Fermer"
          ></button>
        </div>
        <div className="detail-content">
          {content}
        </div>
        <div className="mt-4 text-end">
          <button 
            className="btn btn-secondary" 
            onClick={() => setShowDetails(false)}
            style={{borderRadius: '6px'}}
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};




  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  // Interface mobile
  if (isMobile) {
    return (
      <div className="mobile-dashboard">
        {/* Header mobile */}
        <header className="mobile-header">
          {mobileDetailView ? (
            <div className="d-flex align-items-center">
              <button className="btn btn-link text-dark" onClick={handleBackToList}>
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <h5 className="mb-0 ms-2">
                {mobileDetailView.type === 'rdv' && 'Détails du rendez-vous'}
                {mobileDetailView.type === 'patient' && `${mobileDetailView.item.prenom} ${mobileDetailView.item.nom}`}
              </h5>
            </div>
          ) : (
            <>
              <h5 className="mb-0">Dr. {medecinData?.prenom} {medecinData?.nom}</h5>
              <div>
                <button className="btn btn-link text-dark ms-2" onClick={() => setShowMobileMenu(!showMobileMenu)}>
                  <FontAwesomeIcon icon={faBars} />
                </button>
              </div>
            </>
          )}
        </header>

        {/* Menu mobile */}
        {showMobileMenu && (
          <div className="mobile-menu">
            <div className="list-group list-group-flush">
              <button className="list-group-item list-group-item-action d-flex align-items-center" onClick={() => handleMobileTabChange('info')}>
                <FontAwesomeIcon icon={faUserMd} className="me-3" />
                Mon Profil
              </button>
              <button className="list-group-item list-group-item-action d-flex align-items-center" onClick={() => handleMobileTabChange('rendezvous')}>
                <FontAwesomeIcon icon={faCalendarAlt} className="me-3" />
                Rendez-vous
                <span className="badge bg-info ms-2">{rendezvous.length}</span>
              </button>
              <button className="list-group-item list-group-item-action d-flex align-items-center" onClick={() => handleMobileTabChange('patients')}>
                <FontAwesomeIcon icon={faUser} className="me-3" />
                Patients
                <span className="badge bg-info ms-2">{patients.length}</span>
              </button>

              <button className="list-group-item list-group-item-action d-flex align-items-center" onClick={() => handleMobileTabChange('messagerie')}>

                <FontAwesomeIcon icon={faComments} className="me-3" />Messagerie
                {unreadMessagesCount > 0 && (
                  <span className="badge bg-danger position-absolute top-0 end-0 translate-middle-x">{unreadMessagesCount}</span>
                )}
              </button>


              <button className="list-group-item list-group-item-action d-flex align-items-center position-relative" onClick={() => handleMobileTabChange('affiliations')}>
                <FontAwesomeIcon icon={faClinicMedical} className="me-3" />
                Affiliations
                {pendingAffiliations.length > 0 && 
                  <span className="badge bg-danger position-absolute" style={{
                    top: '10px',
                    right: '10px',
                    fontSize: '0.75rem',
                    fontWeight: 'bold',
                    padding: '0.35em 0.65em',
                    borderRadius: '50%',
                    minWidth: '20px',
                    height: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>{pendingAffiliations.length}</span>
                }
              </button>
                {/* Dans le menu mobile */}
                <button className="list-group-item list-group-item-action d-flex align-items-center" onClick={() => handleMobileTabChange('archives')}>
                              <FontAwesomeIcon icon={faArchive} className="me-3" />
                              Archives
                            </button>
              
              <button className="list-group-item list-group-item-action d-flex align-items-center" onClick={() => handleMobileTabChange('password')}>
                <FontAwesomeIcon icon={faKey} className="me-3" />
                Mot de passe
              </button>
              <button className="list-group-item list-group-item-action d-flex align-items-center" onClick={handleLogout}>
                <FontAwesomeIcon icon={faSignOutAlt} className="me-3" />
                Déconnexion
              </button>
            </div>
          </div>
        )}

        {/* Contenu principal mobile */}
        <div className="mobile-content">
          {/* Affichage des messages de notification */}
          {message && (
            <div className={`alert alert-dismissible fade show ${message.includes('Erreur') ? 'alert-danger' : 'alert-success'}`} role="alert">
              {message}
              <button type="button" className="btn-close" onClick={() => setMessage('')}></button>
            </div>
          )}

          {/* Vue détaillée mobile */}
          {mobileDetailView && (
            <div className="mobile-detail-view">
              {/* Détail d'un rendez-vous */}
              {mobileDetailView.type === 'rdv' && (
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <div className={`status-indicator status-${mobileDetailView.item.statut}`}>
                      {mobileDetailView.item.statut.charAt(0).toUpperCase() + mobileDetailView.item.statut.slice(1)}
                    </div>
                    
                    <div className="info-item">
                      <strong>Patient:</strong> {mobileDetailView.item.patientNom || 'Non spécifié'}
                      <button 
                        className="btn btn-sm btn-outline-primary ms-2"
                        onClick={() => handleViewPatient(mobileDetailView.item.patientId)}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                    </div>
                    
                    <div className="info-item">
                      <strong>Structure:</strong> {getStructureById(mobileDetailView.item.structureId).nom}
                    </div>
                    
                    <div className="info-item">
                      <strong>Date:</strong> {new Date(mobileDetailView.item.date).toLocaleDateString()}
                    </div>
                    
                    <div className="info-item">
                      <strong>Heure:</strong> {mobileDetailView.item.heure}
                    </div>
                    
                   
                    
                    <div className="info-item">
                      <strong>Motif:</strong> {mobileDetailView.item.motif || 'Non spécifié'}
                    </div>
                  </div>
                </div>
              )}
              
              {/* Détail d'un patient */}
              {mobileDetailView.type === 'patient' && (
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <div className="text-center mb-4">
                      <div className="avatar-circle bg-info text-white">
                        {mobileDetailView.item.prenom?.charAt(0)}{mobileDetailView.item.nom?.charAt(0)}
                      </div>
                      <h4 className="mt-3">{mobileDetailView.item.prenom} {mobileDetailView.item.nom}</h4>
                      <span className="badge bg-secondary">
                        {calculateAge(mobileDetailView.item.dateNaissance)} ans
                      </span>
                    </div>
                    
                    <div className="info-item">
                      <strong>Date de naissance:</strong> {new Date(mobileDetailView.item.dateNaissance).toLocaleDateString()}
                    </div>
                    
                    <div className="info-item">
                      <FontAwesomeIcon icon={faPhone} className="me-3 text-secondary" />
                      {mobileDetailView.item.telephone}
                    </div>
                    
                    <div className="info-item">
                      <FontAwesomeIcon icon={faEnvelope} className="me-3 text-secondary" />
                      {mobileDetailView.item.email}
                    </div>
                    
                    <div className="info-item">
                      <strong>Sexe:</strong> {mobileDetailView.item.sexe || 'Non spécifié'}
                    </div>
                    
                    <div className="info-item">
                      <strong>Adresse:</strong> {mobileDetailView.item.adresse || 'Non spécifiée'}
                    </div>
                    
                    <h6 className="mt-4 mb-3">Assurances</h6>
                    <div>
                      {mobileDetailView.item.assurances && mobileDetailView.item.assurances.map((assurance, index) => (
                        <span key={index} className="badge bg-light text-dark me-1 mb-1">
                          {assurance}
                        </span>
                      ))}
                      {mobileDetailView.item.numeroAssurance && (
                        <div className="mt-2">
                          <small className="text-muted">Numéro d'assurance: {mobileDetailView.item.numeroAssurance}</small>
                        </div>
                      )}
                    </div>
                    
                    {mobileDetailView.item.antecedentsMedicaux && (
                      <div className="mt-4">
                        <h6>Antécédents médicaux</h6>
                        <p className="text-muted">{mobileDetailView.item.antecedentsMedicaux}</p>
                      </div>
                    )}
                    <div className="info-item">
                      <strong>Diagnostic:</strong>
                      <p className="text-muted mb-0">
                        {mobileDetailView.item.diagnostics || 'Non spécifié'}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Vue liste mobile pour chaque onglet */}
          {!mobileDetailView && (
            <>



              {/* Onglet Profil */}
              {activeTab === 'info' && (
                <div className="mobile-info-view">
                  <div className="card border-0" style={{
                    backgroundColor: '#f0f8ff',
                    borderRadius: '12px',
                    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
                    border: '1px solid #e0f0ff'
                  }}>
                    <div className="card-body p-4">
                      <div className="text-center mb-4">
                        <div style={{
                          width: '80px',
                          height: '80px',
                          borderRadius: '50%',
                          backgroundColor: '#2c7be5',
                          color: 'white',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '1.8rem',
                          margin: '0 auto',
                          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)'
                        }}>
                          {medecinData?.prenom?.charAt(0)}{medecinData?.nom?.charAt(0)}
                        </div>
                        <h4 className="mt-3" style={{ color: '#2c7be5' }}>Dr. {medecinData?.prenom} {medecinData?.nom}</h4>
                        <span style={{ 
                          backgroundColor: '#e6f2ff', 
                          color: '#2c7be5',
                          padding: '6px 12px',
                          borderRadius: '20px',
                          fontSize: '0.9rem'
                        }}>
                          {medecinData?.specialite}
                        </span>
                      </div>
                      
                      <div style={{
                        backgroundColor: 'white',
                        borderRadius: '10px',
                        padding: '20px',
                        marginBottom: '15px',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
                      }}>
                        <div className="mb-3">
                          <label className="form-label" style={{ color: '#4a6fa5', fontWeight: '500' }}>Nom</label>
                          <input
                            name="nom"
                            value={form.nom || ''}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Nom"
                            style={{ borderRadius: '6px', border: '1px solid #e0f0ff' }}
                          />
                        </div>
                        
                        <div className="mb-3">
                          <label className="form-label" style={{ color: '#4a6fa5', fontWeight: '500' }}>Prénom</label>
                          <input
                            name="prenom"
                            value={form.prenom || ''}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Prénom"
                            style={{ borderRadius: '6px', border: '1px solid #e0f0ff' }}
                          />
                        </div>
                        
                        <div className="mb-3">
                          <label className="form-label" style={{ color: '#4a6fa5', fontWeight: '500' }}>Spécialité</label>
                          <input
                            name="specialite"
                            value={form.specialite || ''}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Spécialité"
                            style={{ borderRadius: '6px', border: '1px solid #e0f0ff' }}
                          />
                        </div>
                        
                        <div className="mb-3">
                          <label className="form-label" style={{ color: '#4a6fa5', fontWeight: '500' }}>Téléphone</label>
                          <input
                            name="telephone"
                            value={form.telephone || ''}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Téléphone"
                            style={{ borderRadius: '6px', border: '1px solid #e0f0ff' }}
                          />
                        </div>
                        
                        <div className="mb-3">
                          <label className="form-label" style={{ color: '#4a6fa5', fontWeight: '500' }}>Email</label>
                          <input
                            name="email"
                            value={form.email || ''}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Email"
                            disabled
                            style={{ borderRadius: '6px', backgroundColor: '#f8f9fa', border: '1px solid #e0f0ff' }}
                          />
                        </div>
                      </div>
                      
                      <div style={{
                        backgroundColor: 'white',
                        borderRadius: '10px',
                        padding: '20px',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
                      }}>
                        <h5 style={{ color: '#2c7be5', marginBottom: '15px' }}>Disponibilités</h5>
                        <div className="table-responsive">
                          <table className="table table-sm" style={{ borderCollapse: 'separate', borderSpacing: '0 5px' }}>
                            <thead>
                              <tr>
                                <th style={{ color: '#4a6fa5', fontWeight: '500' }}>Jour</th>
                                <th style={{ color: '#4a6fa5', fontWeight: '500' }}>Actif</th>
                                <th style={{ color: '#4a6fa5', fontWeight: '500' }}>Début</th>
                                <th style={{ color: '#4a6fa5', fontWeight: '500' }}>Fin</th>
                              </tr>
                            </thead>
                            <tbody>
                              {form.disponibilites && Object.entries(form.disponibilites).map(([jour, dispo]) => (
                                <tr key={jour} style={{ backgroundColor: dispo.actif ? '#f8fbff' : 'white' }}>
                                  <td>{jour.charAt(0).toUpperCase() + jour.slice(1)}</td>
                                  <td>
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name={`disponibilites.${jour}.actif`}
                                        checked={dispo.actif || false}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <input
                                      type="time"
                                      className="form-control form-control-sm"
                                      name={`disponibilites.${jour}.debut`}
                                      value={dispo.debut || '08:00'}
                                      onChange={handleChange}
                                      disabled={!dispo.actif}
                                      style={{ 
                                        borderRadius: '6px', 
                                        border: '1px solid #e0f0ff',
                                        opacity: dispo.actif ? '1' : '0.6'
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="time"
                                      className="form-control form-control-sm"
                                      name={`disponibilites.${jour}.fin`}
                                      value={dispo.fin || '18:00'}
                                      onChange={handleChange}
                                      disabled={!dispo.actif}
                                      style={{ 
                                        borderRadius: '6px', 
                                        border: '1px solid #e0f0ff',
                                        opacity: dispo.actif ? '1' : '0.6'
                                      }}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      
                      <div className="d-grid mt-4">
                        <button onClick={handleUpdate} className="btn btn-primary" style={{
                          borderRadius: '8px',
                          padding: '12px',
                          fontWeight: '500',
                          boxShadow: '0 4px 6px rgba(44, 123, 229, 0.2)'
                        }}>
                          <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                          Mettre à jour
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Onglet Rendez-vous */}
              {activeTab === 'rendezvous' && (
                <div className="mobile-rendezvous-view">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="btn-group">
                      <button 
                        className={`btn btn-sm ${viewMode === 'calendar' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setViewMode('calendar')}
                      >
                        <FontAwesomeIcon icon={faCalendarAlt} className="me-1" />
                        Calendrier
                      </button>
                      <button 
                        className={`btn btn-sm ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setViewMode('list')}
                      >
                        <FontAwesomeIcon icon={faList} className="me-1" />
                        Liste
                      </button>
                    </div>
                    
                    <div className="dropdown">
                      <button className="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" id="filterDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                        <FontAwesomeIcon icon={faCalendarCheck} className="me-1" />
                        Filtres
                      </button>
                      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="filterDropdown">
                        <li className="px-3 py-2">
                          <label className="form-label">Date</label>
                          <input 
                            type="date" 
                            className="form-control form-control-sm" 
                            value={filtreDate}
                            onChange={(e) => setFiltreDate(e.target.value)}
                          />
                        </li>
                        <li><hr className="dropdown-divider" /></li>
                        <li className="px-3 py-2">
                          <label className="form-label">Statut</label>
                          <select 
                            className="form-select form-select-sm"
                            value={filtreStatut}
                            onChange={(e) => setFiltreStatut(e.target.value)}
                          >
                            <option value="tous">Tous statuts</option>
                            <option value="confirmé">Confirmé</option>
                            <option value="terminé">Terminé</option>
                            <option value="annulé">Annulé</option>
                          </select>
                        </li>
                        <li><hr className="dropdown-divider" /></li>
                        <li className="px-3 py-2">
                          <label className="form-label">Structure</label>
                          <select 
                            className="form-select form-select-sm"
                            value={filtreStructure}
                            onChange={(e) => setFiltreStructure(e.target.value)}
                          >
                            <option value="">Toutes structures</option>
                            {affiliatedStructures.map(structure => (
                              <option key={structure.id} value={structure.id}>
                                {structure.nom}
                              </option>
                            ))}
                          </select>
                        </li>
                      </ul>
                    </div>
                  </div>
                  
                  {viewMode === 'calendar' ? (
                    <>
                      <div className="calendar-header-mobile d-flex justify-content-between align-items-center mb-3">
                        <button className="btn btn-sm btn-outline-secondary" onClick={handlePrevMonth}>
                          <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        <h6 className="mb-0">
                          {currentMonth.toLocaleString('fr-FR', { month: 'long', year: 'numeric' })}
                        </h6>
                        <button className="btn btn-sm btn-outline-secondary" onClick={handleNextMonth}>
                          <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                      </div>
                      
                      <div className="calendar-mobile mb-4">
                        <div className="calendar-days">
                          {['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((day, index) => (
                            <div key={index} className="calendar-day-header">
                              {day}
                            </div>
                          ))}
                        </div>
                        
                        <div className="calendar-body">
                          {getMonthData().map((day, index) => (
                           <div 
                           key={index} 
                           className={`calendar-day ${!day.isCurrentMonth ? 'other-month' : ''} ${day.hasEvents ? 'has-events' : ''}`}
                           onClick={() => handleMobileDateClick(day)}
                         >
                           <div className="date-number">{day.date.getDate()}</div>
                           {day.hasEvents && (
                             <div className="event-dot"></div>
                           )}
                         </div>
                         
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="list-group list-group-flush">
                      {filteredRendezvous.length > 0 ? (
                        filteredRendezvous.map((rdv) => (
                          <button
                            key={rdv.id}
                            className="list-group-item list-group-item-action"
                            onClick={() => handleMobileDetailView('rdv', rdv)}
                          >
                            <div className={`rdv-item-mobile status-${rdv.statut}`}>
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <h6 className="mb-0">{rdv.patientNom}</h6>
                                  <small>{getStructureById(rdv.structureId).nom}</small>
                                </div>
                                <div className="text-end">
                                  <span className={`badge status-badge-${rdv.statut}`}>
                                    {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                                  </span>
                                  <div className="small text-muted">
                                    {new Date(rdv.date).toLocaleDateString()} à {rdv.heure}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </button>
                        ))
                      ) : (
                        <div className="text-center py-4">
                          <p className="text-muted">Aucun rendez-vous trouvé</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

            {activeTab === 'patients' && (
              <div>
                {/* Navigation interne adaptée au mobile */}
                <ul className="nav nav-pills nav-fill mb-4 flex-inline flex-sm-row">
                  <li className="nav-item mb-2 mb-sm-0">
                    <button 
                      className={`nav-link w-100 ${patientSubTab === 'list' ? 'active' : ''}`}
                      onClick={() => setPatientSubTab('list')}
                    >
                      <i className="fas fa-list-ul d-block d-sm-none"></i>
                      <span className="d-none d-sm-block">Liste des patients</span>
                    </button>
                  </li>
                  <li className="nav-item">
                    <button 
                      className={`nav-link w-100 ${patientSubTab === 'manage' ? 'active' : ''}`}
                      onClick={() => setPatientSubTab('manage')}
                    >
                      <i className="fas fa-user-cog d-block d-sm-none"></i>
                      <span className="d-none d-sm-block">Gestion des patients</span>
                    </button>
                  </li>
                </ul>
                
                {/* Contenu conditionnel optimisé pour mobile */}
                {patientSubTab === 'list' && (
                  <div className="card shadow-sm">
                    <div className="card-header bg-light">
                      <h5 className="mb-0 fs-6 fs-sm-5">Mes patients</h5>
                    </div>
                    <div className="card-body p-2 p-sm-3">
                      <div className="row g-2 g-sm-4">
                        {patients.length > 0 ? (
                          patients.map((patient) => {
                            // Trouver les rendez-vous associés à ce patient
                            const patientRdvs = rendezvous.filter(rdv => rdv.patientId === patient.id);
                            // Trouver les structures uniques associées aux rendez-vous
                            const structureIds = [...new Set(patientRdvs.map(rdv => rdv.structureId))];
                            const patientStructures = structureIds.map(id => getStructureById(id));
                            
                            return (
                              <div className="col-12" key={patient.id}>
                                <div className="card h-100 shadow-sm hover-card">
                                  <div className="card-body p-3">
                                    <div className="d-flex justify-content-between align-items-start">
                                      <h5 className="card-title fs-6">{patient.prenom} {patient.nom}</h5>
                                      <span className="badge bg-secondary">
                                        {calculateAge(patient.dateNaissance)} ans
                                      </span>
                                    </div>
                                    <div className="row mt-2">
                                      <div className="col-12 col-sm-6">
                                        <p className="card-text small mb-1">
                                          <i className="fas fa-phone me-2 text-secondary"></i>
                                          {patient.telephone || 'Non spécifié'}
                                        </p>
                                      </div>
                                      <div className="col-12 col-sm-6">
                                        <p className="card-text small mb-1">
                                          <i className="fas fa-envelope me-2 text-secondary"></i>
                                          {patient.email || 'Non spécifié'}
                                        </p>
                                      </div>
                                    </div>
                                    {patientStructures.length > 0 && (
                                      <div className="mt-2">
                                        <h6 className="fs-7 mb-1">Structures associées:</h6>
                                        <div className="d-flex flex-wrap">
                                          {patientStructures.map((structure, index) => (
                                            <span key={index} className="badge bg-light text-dark me-1 mb-1 small">
                                              {structure.nom}
                                            </span>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                    <div className="col-12 col-sm-6">
                                      <p className="card-text small mb-1">
                                        <i className="fas fa-stethoscope me-2 text-secondary"></i>
                                        {patient.diagnostics || 'Aucun diagnostic enregistré'}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="card-footer bg-transparent border-top-0 p-2">
                                    <div className="d-flex justify-content-between">
                                      <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={() => handleManualArchivePatient(patient)}
                                        title="Archiver ce patient"
                                      >
                                        <i className="fas fa-archive me-1 d-none d-sm-inline"></i>
                                        Archiver
                                      </button>
                                      <button
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() => handleViewDetails('patient', getPatientById(patient.id))}
                                      >
                                        <i className="fas fa-eye me-1 d-none d-sm-inline"></i>
                                        Détails
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="col-12 text-center py-3 py-sm-5">
                            <p className="text-muted small">Aucun patient associé à vos rendez-vous</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                
                {patientSubTab === 'manage' && (
                  <div className="card shadow-sm">
                   
                    <div className="card-body p-2 p-sm-3">
                      <MedecinPatientManager 
                        medecinId={auth.currentUser?.uid}
                        affiliatedStructures={affiliatedStructures}
                        patients={patients}
                        onPatientAdd={(newPatient) => {
                          setPatients(prevPatients => [...prevPatients, newPatient]);
                        }}
                        onPatientUpdate={(updatedPatient) => {
                          setPatients(prevPatients => 
                            prevPatients.map(p => p.id === updatedPatient.id ? updatedPatient : p)
                          );
                        }}
                        onPatientArchive={(patientId) => {
                          setPatients(prevPatients => 
                            prevPatients.map(p => p.id === patientId ? {...p, archived: true} : p)
                          );
                        }}
                        isMobile={window.innerWidth < 576}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}


{activeTab === 'messagerie' && (
  <div className="mobile-messagerie-view">
    {/* Navigation entre conversations et contacts */}
    <div className="mobile-tabs">
      <button 
        className={`mobile-tab ${mobileMessageTab === 'conversations' ? 'active' : ''}`}
        onClick={() => setMobileMessageTab('conversations')}
      >
        Conversations
        {unreadMessagesCount > 0 && <span className="badge bg-danger ms-1">{unreadMessagesCount}</span>}
      </button>
      <button 
        className={`mobile-tab ${mobileMessageTab === 'contacts' ? 'active' : ''}`}
        onClick={() => setMobileMessageTab('contacts')}
      >
        Patients
      </button>
    </div>
    
    {/* Affichage conditionnel selon l'onglet sélectionné */}
    {mobileMessageTab === 'conversations' && !selectedConversation ? (
      <div className="conversations-list-mobile">
        {conversations.length > 0 ? (
          conversations.map(conversation => (
            <div 
              key={conversation.id}
              className="conversation-item"
              onClick={() => setSelectedConversation(conversation)}
            >
              <div className="avatar-mini me-2">
                {conversation.patient?.prenom?.[0]}{conversation.patient?.nom?.[0]}
              </div>
              <div className="flex-grow-1">
                <div className="d-flex justify-content-between align-items-center">
                  <span className="conversation-name">{conversation.patient?.prenom} {conversation.patient?.nom}</span>
                  {conversation.unreadCount > 0 && (
                    <span className="badge bg-danger rounded-pill">{conversation.unreadCount}</span>
                  )}
                </div>
                <p className="conversation-preview">{conversation.lastMessage || "Nouvelle conversation"}</p>
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <FontAwesomeIcon icon={faComments} size="2x" className="text-muted mb-2" />
            <p>Aucune conversation récente</p>
          </div>
        )}
      </div>
    ) : mobileMessageTab === 'contacts' && !selectedConversation ? (
      <div className="contacts-list-mobile">
        <div className="search-container p-2">
          <input
            type="text"
            className="form-control"
            placeholder="Rechercher un patient..."
            value={searchPatientTerm}
            onChange={(e) => setSearchPatientTerm(e.target.value)}
          />
        </div>
        {filteredMessagePatients.length > 0 ? (
          filteredMessagePatients.map(patient => (
            <div 
              key={patient.id}
              className="contact-item"
              onClick={() => startConversationWithPatient(patient)}
            >
              <div className="avatar-mini me-2">
                {patient.prenom?.[0]}{patient.nom?.[0]}
              </div>
              <span>{patient.prenom} {patient.nom}</span>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <FontAwesomeIcon icon={faUserFriends} size="2x" className="text-muted mb-2" />
            <p>Aucun patient trouvé</p>
          </div>
        )}
      </div>
    ) : (
      /* Vue conversation sélectionnée */
      <div className="mobile-conversation-view">
        <div className="mobile-conversation-header">
          <button 
            className="btn btn-link text-dark p-0 me-2" 
            onClick={() => setSelectedConversation(null)}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>
          <div className="avatar-mini me-2">
            {selectedConversation?.patient?.prenom?.[0]}{selectedConversation?.patient?.nom?.[0]}
          </div>
          <h6 className="mb-0">{selectedConversation?.patient?.prenom} {selectedConversation?.patient?.nom}</h6>
        </div>
        
        <div className="mobile-messages-container">
          {loadingMessages ? (
            <div className="text-center p-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Chargement...</span>
              </div>
            </div>
          ) : messages.length === 0 ? (
            <div className="empty-state">
              <FontAwesomeIcon icon={faComment} size="2x" className="text-muted mb-2" />
              <p>Commencez la conversation!</p>
            </div>
          ) : (
            <div className="mobile-messages-list">
              {messages.map((message, index) => (
                <div 
                  key={message.id || index} 
                  className={`mobile-message ${message.senderId === auth.currentUser.uid ? 'mobile-message-own' : 'mobile-message-other'}`}
                >
                  <div className="mobile-message-content">
                    {message.text && <p className="mobile-message-text">{message.text}</p>}
                    
                    {message.attachment && (
                      <div className="mobile-message-file">
                        <FontAwesomeIcon icon={faFile} className="mobile-message-file-icon" />
                        <div className="mobile-message-file-name">{message.attachment.name}</div>
                        <FontAwesomeIcon 
                          icon={faDownload} 
                          className="mobile-message-file-download" 
                          onClick={() => {
                            const link = document.createElement('a');
                            link.href = message.attachment.url;
                            link.download = message.attachment.name;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }}
                        />
                      </div>
                    )}
                    
                    {message.audioAttachment && (
                      <audio controls src={message.audioAttachment.url} className="w-100 mt-2"></audio>
                    )}
                    
                    <div className="mobile-message-time">
                      {message.timestamp ? (
                        new Date(message.timestamp.seconds * 1000).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
                      ) : ''}
                    </div>
                  </div>
                </div>
              ))}
              <div ref={messagesEndRef} />
            </div>
          )}
        </div>
        
        <form className="mobile-message-input-form" onSubmit={sendMessage}>
          {attachmentFile && (
            <div className="mobile-attachment-preview">
              <div className="mobile-attachment-info">
                <FontAwesomeIcon icon={faFile} className="me-2" />
                <span>{attachmentFile.name}</span>
              </div>
              <button type="button" className="btn-close btn-close-white btn-sm" onClick={removeAttachment}></button>
            </div>
          )}
          
          {audioBlob && !isRecording && (
            <div className="mobile-attachment-preview">
              <div className="mobile-attachment-info">
                <FontAwesomeIcon icon={faMicrophone} className="me-2" />
                <span>Note vocale ({formatRecordingTime(recordingTime)})</span>
              </div>
              <button type="button" className="btn-close btn-close-white btn-sm" onClick={removeAudio}></button>
            </div>
          )}
          
          {isRecording && (
            <div className="mobile-recording-indicator">
              <div className="pulse"></div>
              <span>Enregistrement... {formatRecordingTime(recordingTime)}</span>
              <div className="mobile-recording-controls">
                <button type="button" className="btn btn-sm btn-dark" onClick={cancelRecording}>
                  <FontAwesomeIcon icon={faTimes} />
                </button>
                <button type="button" className="btn btn-sm btn-success" onClick={stopRecording}>
                  <FontAwesomeIcon icon={faCheck} />
                </button>
              </div>
            </div>
          )}
          
          <div className="input-group">
            <button 
              type="button" 
              className="btn btn-light mobile-attach-button"
              onClick={() => document.getElementById('mobile-file-attachment').click()}
            >
              <FontAwesomeIcon icon={faPaperclip} />
            </button>
            <input 
              id="mobile-file-attachment" 
              type="file" 
              className="d-none" 
              onChange={handleMessageFileChange} 
            />
            
            <button 
              type="button" 
              className={`btn ${isRecording ? 'btn-danger' : 'btn-light'} mobile-mic-button`}
              onClick={isRecording ? stopRecording : startRecording}
            >
              <FontAwesomeIcon icon={isRecording ? faStop : faMicrophone} />
            </button>
            
            <input
              type="text"
              className="form-control"
              placeholder="Écrivez votre message..."
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              disabled={sendingMessage || isRecording}
            />
            <button 
              className="btn btn-primary mobile-send-button" 
              type="submit"
              disabled={((!newMessage.trim() && !attachmentFile && !audioBlob) || sendingMessage || isRecording)}
            >
              {sendingMessage ? (
                <FontAwesomeIcon icon={faCircleNotch} spin />
              ) : (
                <FontAwesomeIcon icon={faPaperPlane} />
              )}
            </button>
          </div>
        </form>
      </div>
    )}
  </div>
)}
<style jsx>{`/* Styles pour la messagerie mobile */
.mobile-messagerie-view {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 120px);
  overflow: hidden;
  background-color: #f9fafb; /* Fond légèrement plus clair pour un look épuré */
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif; /* Police moderne */
}

.mobile-tabs {
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08); /* Bordure plus subtile */
  background-color: #ffffff;
  padding: 0 4px;
}

.mobile-tab {
  flex: 1;
  text-align: center;
  padding: 14px 8px;
  background: none;
  border: none;
  font-weight: 500;
  font-size: 0.95rem;
  color: #64748b; /* Couleur plus douce */
  position: relative;
  transition: all 0.2s ease;
}

.mobile-tab.active {
  color: #0369a1; /* Bleu plus profond et moins saturé */
  border-bottom: 2px solid #0369a1;
}

.conversations-list-mobile, .contacts-list-mobile {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 60px;
  background-color: #ffffff; /* Fond blanc pour la liste */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05); /* Ombre très subtile */
}

.conversation-item, .contact-item {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04); /* Bordure très légère */
  cursor: pointer;
  transition: background-color 0.2s;
}

.conversation-item:active, .contact-item:active {
  background-color: rgba(0, 0, 0, 0.03); /* Effet de pression très subtil */
}

.conversation-name {
  font-weight: 600;
  margin-bottom: 3px;
  color: #1e293b; /* Texte plus foncé pour meilleure lisibilité */
}

.conversation-preview {
  font-size: 0.85rem;
  color: #64748b; /* Gris bleuté plus doux */
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  line-height: 1.3;
}

.mobile-conversation-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f8fafc; /* Fond très légèrement texturé */
}

.mobile-conversation-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background-color: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.mobile-messages-container {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background-color: #f8fafc; /* Fond très légèrement texturé */
  background-image: linear-gradient(rgba(255, 255, 255, 0.5) 1px, transparent 1px),
                    linear-gradient(90deg, rgba(255, 255, 255, 0.5) 1px, transparent 1px);
  background-size: 20px 20px; /* Motif de grille très subtil */
  background-position: center center;
}

.mobile-message {
  margin-bottom: 12px;
  max-width: 80%;
  clear: both;
}

.mobile-message-own {
  float: right;
}

.mobile-message-other {
  float: left;
}

.mobile-message-content {
  padding: 10px 14px;
  border-radius: 18px;
  display: inline-block;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04); /* Ombre très légère */
}

.mobile-message-own .mobile-message-content {
  background-color: #0284c7; /* Bleu moins saturé */
  background-image: linear-gradient(135deg, #0284c7, #0369a1); /* Dégradé subtil */
  color: white;
  border-bottom-right-radius: 6px;
}

.mobile-message-other .mobile-message-content {
  background-color: white;
  color: #1e293b; /* Texte plus foncé */
  border-bottom-left-radius: 6px;
}

.mobile-message-text {
  margin-bottom: 4px;
  word-break: break-word;
  line-height: 1.4;
  font-size: 0.95rem;
}

.mobile-message-time {
  font-size: 0.7rem;
  opacity: 0.8;
  text-align: right;
}

.mobile-message-input-form {
  padding: 12px;
  background-color: white;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.mobile-message-input-form .input-group {
  background-color: #f1f5f9;
  border-radius: 24px;
  padding: 4px;
}

.mobile-message-input-form .form-control {
  border: none;
  background-color: transparent;
  box-shadow: none;
  padding-left: 16px;
}

.mobile-message-input-form .btn {
  border-radius: 50%;
  width: 38px;
  height: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 30px;
  text-align: center;
  color: #64748b;
  background-color: rgba(255, 255, 255, 0.7); /* Fond légèrement transparent */
}

.search-container {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.search-container .form-control {
  background-color: #f1f5f9;
  border: none;
  border-radius: 20px;
  padding-left: 16px;
  font-size: 0.9rem;
}

/* Ajout d'animations subtiles */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

.mobile-message {
  animation: fadeIn 0.2s ease-out;
}

/* Styles pour l'avatar */
.avatar-mini {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0f2fe; /* Bleu très clair */
  color: #0284c7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.85rem;
  margin-right: 12px;
}

.mobile-attachment-preview {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.05);
  padding: 8px 12px;
  border-radius: 8px;
  margin: 8px 12px;
}

.mobile-attachment-info {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: #333;
}

.mobile-recording-indicator {
  display: flex;
  align-items: center;
  background-color: #fee2e2;
  padding: 8px 12px;
  border-radius: 8px;
  margin: 8px 12px;
  color: #b91c1c;
}

.mobile-recording-controls {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

.mobile-message-input-form {
  padding: 8px 0;
  background-color: white;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.mobile-message-input-form .input-group {
  padding: 0 8px;
}

.mobile-attach-button, .mobile-mic-button {
  width: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-send-button {
  width: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
`}</style>

              {/* Onglet Affiliations */}
              {activeTab === 'affiliations' && (
                <div className="mobile-affiliations-view">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0">Rechercher des structures</h6>
                    <button 
                      className="btn btn-sm btn-outline-secondary"
                      onClick={refreshAffiliations}
                      disabled={loading}
                    >
                      <FontAwesomeIcon icon={faSync} className={loading ? "fa-spin" : ""} />
                    </button>
                  </div>
                  <div className="mb-3">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Rechercher une structure..."
                        value={searchStructure}
                        onChange={(e) => setSearchStructure(e.target.value)}
                      />
                      <button className="btn btn-outline-primary" type="button">
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <select 
                      className="form-select"
                      value={filtreSpecialite}
                      onChange={(e) => setFiltreSpecialite(e.target.value)}
                    >
                      <option value="">Toutes spécialités</option>
                      {specialites.map((specialite, index) => (
                        <option key={index} value={specialite}>{specialite}</option>
                      ))}
                    </select>
                  </div>
                  
                  {filteredStructures.map(structure => {
  // Vérifier si déjà affilié ou demande en cours
  const isAffiliated = affiliatedStructures.some(s => s.id === structure.id);
  const hasPendingRequest = sentAffiliationRequests.some(req => 
    req.structureId === structure.id && req.status === "pending"
  );
  const hasRejectedRequest = sentAffiliationRequests.some(req => 
    req.structureId === structure.id && req.status === "rejected"
  );
  
  // Vérifier si récemment désaffilié
  const recentlyDisaffiliated = wasRecentlyDisaffiliated(structure.id);
  
  return (
    <div key={structure.id} className="card mb-3">
      <div className="card-body">
        <h6 className="card-title">{structure.nom}</h6>
        {structure.specialites && structure.specialites.length > 0 && (
          <div className="mb-2">
            {structure.specialites.map((specialite, index) => (
              <span key={index} className="badge bg-light text-dark me-1 mb-1">
                {specialite}
              </span>
            ))}
          </div>
        )}
        <p className="card-text small">
          <FontAwesomeIcon icon={faMapMarkerAlt} className="me-1" />
          {structure.adresse || 'Adresse non spécifiée'}
        </p>
        <div className="d-grid">
          {isAffiliated ? (
            <span className="badge bg-success d-block p-2">Affilié</span>
          ) : hasPendingRequest ? (
            <span className="badge bg-warning text-dark d-block p-2">Demande en attente</span>
          ) : hasRejectedRequest ? (
            <span className="badge bg-danger d-block p-2">Demande rejetée</span>
          ) : recentlyDisaffiliated ? (
            <div>
              <span className="badge bg-secondary d-block p-2 mb-2">Récemment désaffilié</span>
              <small className="text-muted d-block mb-2">Vous pourrez demander une nouvelle affiliation dans quelques jours</small>
            </div>
          ) : (
            <button 
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleRequestAffiliation(structure.id)}
            >
              <FontAwesomeIcon icon={faLink} className="me-1" />
              Demander affiliation
            </button>
          )}
          
        </div>
      </div>
    </div>
  );
})}


                  
                  <h6 className="mb-3 mt-4">Mes demandes d'affiliation</h6>
                  {sentAffiliationRequests.filter(req => req.status === "pending").length > 0 ? (
                    sentAffiliationRequests.filter(req => req.status === "pending").map(request => (
                      <div key={request.id} className="card mb-3">
                        <div className="card-body">
                          <h6 className="card-title">{request.structureName}</h6>
                          <p className="card-text small text-muted">
                            Demande envoyée le {new Date(request.createdAt.toDate()).toLocaleDateString()}
                          </p>
                          <div className="d-grid">
                            <button 
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleCancelRequest(request.id)}
                            >
                              <FontAwesomeIcon icon={faTimes} className="me-1" />
                              Annuler la demande
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="alert alert-info">
                      Aucune demande d'affiliation en cours
                    </div>
                  )}
                  
                  <h6 className="mb-3 mt-4">Mes structures affiliées</h6>
                  {affiliatedStructures.length > 0 ? (
                    affiliatedStructures.map(structure => (
                      <div key={structure.id} className="card mb-3">
                        <div className="card-body">
                          <h6 className="card-title">{structure.nom}</h6>
                          <p className="card-text small">
                            <FontAwesomeIcon icon={faPhone} className="me-1" />
                            {structure.telephone || 'Non spécifié'}
                          </p>
                          <p className="card-text small">
                            <FontAwesomeIcon icon={faEnvelope} className="me-1" />
                            {structure.email || 'Non spécifié'}
                          </p>
                          <div className="d-grid mt-2">
                            <button 
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleDesaffiliation(structure.id)}
                            >
                              <FontAwesomeIcon icon={faUnlink} className="me-1" />
                              Se désaffilier
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="alert alert-info">
                      Aucune structure affiliée
                    </div>
                  )}
                </div>
              )}

{/* Onglet Archives mobile */}
{activeTab === 'archives' && (
  <div className="mobile-archives-view">
    <div className="mb-3">
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          placeholder="Rechercher un patient..."
          value={searchArchive}
          onChange={(e) => setSearchArchive(e.target.value)}
        />
        <button className="btn btn-outline-primary" type="button">
          <FontAwesomeIcon icon={faSearch} />
        </button>
      </div>
    </div>
    
    <div className="list-group list-group-flush">
      {archives.filter(archive => 
        archive.patient.nom.toLowerCase().includes(searchArchive.toLowerCase()) ||
        archive.patient.prenom.toLowerCase().includes(searchArchive.toLowerCase())
      ).map(archive => (
        <button
          key={archive.id}
          className="list-group-item list-group-item-action"
          onClick={() => handleMobileDetailView('archive', archive)}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h6 className="mb-0">{archive.patient.prenom} {archive.patient.nom}</h6>
              <small className="text-muted">
                Dernière visite: {new Date(archive.lastVisit).toLocaleDateString()}
              </small>
            </div>
            <div className="text-end">
              <span className="badge bg-info">{archive.rendezVous?.length || 0} RDV</span>
            </div>
          </div>
        </button>
      ))}
      {archives.length === 0 && (
        <div className="text-center py-4">
          <p className="text-muted">Aucune archive trouvée</p>
        </div>
      )}
    </div>
  </div>
)}




              {/* Onglet Mot de passe */}
              {activeTab === 'password' && (
                <div className="mobile-password-view">
                  <div className="card border-0 shadow-sm">
                    <div className="card-body">
                      <form onSubmit={(e) => { e.preventDefault(); handlePasswordChange(); }}>
                        <div className="mb-3">
                          <label className="form-label">Nouveau mot de passe</label>
                          <input
                            type="password"
                            className="form-control"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                          />
                        </div>
                        <div className="d-grid">
                          <button type="submit" className="btn btn-primary">
                            <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                            Mettre à jour le mot de passe
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        {/* Navigation mobile */}
        <nav className="mobile-nav">
          <button 
            className={`nav-item ${activeTab === 'info' ? 'active' : ''}`} 
            onClick={() => handleMobileTabChange('info')}
          >
            <FontAwesomeIcon icon={faUserMd} />
          </button>
          <button 
            className={`nav-item ${activeTab === 'rendezvous' ? 'active' : ''}`} 
            onClick={() => handleMobileTabChange('rendezvous')}
          >
            <FontAwesomeIcon icon={faCalendarAlt} />
          </button>
          <button 
            className={`nav-item ${activeTab === 'patients' ? 'active' : ''}`} 
            onClick={() => handleMobileTabChange('patients')}
          >
            <FontAwesomeIcon icon={faUser} />
          </button>
          <button 
            className={`nav-item messaging-btn ${activeTab === 'messagerie' ? 'active' : ''}`} 
            onClick={() => handleMobileTabChange('messagerie')}
          >
            <FontAwesomeIcon icon={faComments} />
            {unreadMessagesCount > 0 && (
              <span className="unread-badge">{unreadMessagesCount}</span>
            )}
          </button>
          <button 
            className={`nav-item ${activeTab === 'affiliations' ? 'active' : ''}`} 
            onClick={() => handleMobileTabChange('affiliations')}
          >
            <FontAwesomeIcon icon={faClinicMedical} />
          </button>
        </nav>

{/* Vue détaillée d'une archive en mobile */}
{mobileDetailView && mobileDetailView.type === 'archive' && (
  <div className="mobile-detail-view" style={{ position: 'fixed', top: '56px', left: 0, right: 0, bottom: '56px', overflowY: 'auto', backgroundColor: '#fff', zIndex: 900, padding: '15px' }}>
    
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-body">
        <h5 className="card-title">Patient</h5>
        <div className="text-center mb-3">
          <div className="avatar-circle bg-info text-white mx-auto">
            {mobileDetailView.item.patient.prenom?.charAt(0)}{mobileDetailView.item.patient.nom?.charAt(0)}
          </div>
          <h5 className="mt-2">{mobileDetailView.item.patient.prenom} {mobileDetailView.item.patient.nom}</h5>
          <span className="badge bg-secondary">
            {calculateAge(mobileDetailView.item.patient.dateNaissance)} ans
          </span>
        </div>
        
        <div className="mb-2">
          <strong>Date de naissance:</strong> {new Date(mobileDetailView.item.patient.dateNaissance).toLocaleDateString()}
        </div>
        
        <div className="mb-2">
          <strong>Téléphone:</strong> {mobileDetailView.item.patient.telephone || 'Non spécifié'}
        </div>
        
        <div className="mb-2">
          <strong>Email:</strong> {mobileDetailView.item.patient.email || 'Non spécifié'}
        </div>
      </div>
    </div>
    
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-header bg-white">
        <h5 className="card-title mb-0">Rendez-vous</h5>
      </div>
      <div className="card-body" style={{ maxHeight: '200px', overflowY: 'auto' }}>
        {mobileDetailView.item.rendezVous && mobileDetailView.item.rendezVous.length > 0 ? (
          mobileDetailView.item.rendezVous.map((rdv, index) => (
            <div key={index} className={`rdv-item-mobile status-${rdv.statut} mb-2 p-2 border-bottom`}>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <small>{new Date(rdv.date).toLocaleDateString()} à {rdv.heure}</small>
                  <div>{rdv.structureName}</div>
                  <small className="text-muted">{rdv.motif || 'Aucun motif spécifié'}</small>
                </div>
                <span className={`badge status-badge-${rdv.statut}`}>
                  {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                </span>
              </div>
            </div>
          ))
        ) : (
          <p className="text-muted">Aucun rendez-vous enregistré</p>
        )}
      </div>
    </div>
    
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-header bg-white">
        <h5 className="card-title mb-0">Notes</h5>
      </div>
      <div className="card-body">
        <div className="mb-3">
          <textarea 
            className="form-control" 
            rows="4"
            value={archiveNotes}
            onChange={(e) => setArchiveNotes(e.target.value)}
            placeholder="Ajoutez vos notes concernant ce patient ici..."
          ></textarea>
        </div>
        <div className="d-grid">
          <button 
            className="btn btn-primary"
            onClick={() => {
              handleSaveArchiveNotes();
              // Afficher un toast de confirmation
              const toast = document.createElement('div');
              toast.className = 'toast-notification';
              toast.textContent = 'Notes enregistrées';
              document.body.appendChild(toast);
              setTimeout(() => document.body.removeChild(toast), 2000);
            }}
          >
            <FontAwesomeIcon icon={faSave} className="me-2" />
            Enregistrer les notes
          </button>
        </div>
      </div>
    </div>
    
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-header bg-white d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">Fichiers</h5>
        <label htmlFor="mobileArchiveFile" className="btn btn-sm btn-outline-primary mb-0">
          <FontAwesomeIcon icon={faFileUpload} className="me-1" />
          Ajouter
        </label>
      </div>
      <div className="card-body">
        <input 
          type="file" 
          className="form-control d-none" 
          id="mobileArchiveFile" 
          onChange={handleArchiveFileChange}
        />
        
        {archiveFiles && archiveFiles.some(file => file.isNew) && (
          <div className="mb-3 p-2 bg-light rounded">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <strong>Fichiers à téléverser:</strong>
              </div>
              <button 
                className="btn btn-sm btn-primary"
                onClick={handleArchiveFileUpload}
              >
                <FontAwesomeIcon icon={faFileUpload} className="me-1" />
                Téléverser
              </button>
            </div>
            <div className="mt-2" style={{ maxHeight: '100px', overflowY: 'auto' }}>
              {archiveFiles.filter(file => file.isNew).map((file, index) => (
                <div key={`new-${index}`} className="small text-truncate">
                  <FontAwesomeIcon icon={faFileAlt} className="me-1 text-primary" />
                  {file.name}
                </div>
              ))}
            </div>
          </div>
        )}
        
        <div className="list-group" style={{ maxHeight: '200px', overflowY: 'auto' }}>
          {mobileDetailView.item.files && mobileDetailView.item.files
            .filter(file => !file.isNew)
            .map((file, index) => (
            <div key={index} className="list-group-item list-group-item-action py-2 px-3">
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-truncate" style={{ maxWidth: '70%' }}>
                  <FontAwesomeIcon icon={faFileAlt} className="me-2 text-primary" />
                  {file.name}
                </div>
                <div>
                  <button 
                    className="btn btn-sm btn-outline-primary me-1"
                    onClick={() => handleDownloadArchiveFile(file)}
                  >
                    <FontAwesomeIcon icon={faFileDownload} />
                  </button>
                  <button 
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => handleDeleteArchiveFile(file.id)}
                  >
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </button>
                </div>
              </div>
            </div>
          ))}
          {(!mobileDetailView.item.files || mobileDetailView.item.files.length === 0) && (
            <div className="text-center py-3 text-muted">
              Aucun fichier associé à ce patient
            </div>
          )}
        </div>
      </div>
    </div>
    
    <div className="d-grid gap-2 mb-5 px-2">
      <button 
        className="btn btn-danger"
        onClick={() => {
          if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement cette archive ?")) {
            handleDeleteArchive(mobileDetailView.item.id);
            setMobileDetailView(null);
          }
        }}
      >
        <FontAwesomeIcon icon={faTrashAlt} className="me-1" />
        Supprimer cette archive
      </button>
    </div>
    
    {/* Espace supplémentaire en bas pour éviter que le dernier élément soit caché par la navigation */}
    <div style={{ height: '60px' }}></div>
  </div>
)}


        {/* Modal pour afficher les détails d'un patient */}
        {showPatientModal && selectedPatient && (
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Détails du patient</h5>
                  <button type="button" className="btn-close" onClick={() => setShowPatientModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="text-center mb-3">
                    <div className="avatar-circle bg-info text-white mx-auto">
                      {selectedPatient.prenom?.charAt(0)}{selectedPatient.nom?.charAt(0)}
                    </div>
                    <h5 className="mt-2">{selectedPatient.prenom} {selectedPatient.nom}</h5>
                    <span className="badge bg-secondary">
                      {calculateAge(selectedPatient.dateNaissance)} ans
                    </span>
                  </div>
                  
                  <div className="mb-2">
                    <strong>Date de naissance:</strong> {new Date(selectedPatient.dateNaissance).toLocaleDateString()}
                  </div>
                  
                  <div className="mb-2">
                    <strong>Téléphone:</strong> {selectedPatient.telephone}
                  </div>
                  
                  <div className="mb-2">
                    <strong>Email:</strong> {selectedPatient.email}
                  </div>
                  
                  <div className="mb-2">
                    <strong>Sexe:</strong> {selectedPatient.sexe || 'Non spécifié'}
                  </div>
                  
                  <div className="mb-2">
                    <strong>Adresse:</strong> {selectedPatient.adresse || 'Non spécifiée'}
                  </div>
                  
                  <div className="mb-2">
                    <strong>Assurances:</strong>
                    <div>
                      {selectedPatient.assurances && selectedPatient.assurances.map((assurance, index) => (
                        <span key={index} className="badge bg-light text-dark me-1 mb-1">
                          {assurance}
                        </span>
                      ))}
                    </div>
                    {selectedPatient.numeroAssurance && (
                      <small className="text-muted">
                        Numéro d'assurance: {selectedPatient.numeroAssurance}
                      </small>
                    )}
                  </div>
                  
                  {selectedPatient.antecedentsMedicaux && (
                    <div className="mb-2">
                      <strong>Antécédents médicaux:</strong>
                      <p className="text-muted">{selectedPatient.antecedentsMedicaux}</p>
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowPatientModal(false)}>
                    Fermer
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      {/* Vue détaillée d'une archive en mobile */}
{mobileDetailView && mobileDetailView.type === 'archive' && (
  <div className="mobile-detail-view" style={{ height: '100%', overflowY: 'auto', paddingBottom: '20px' }}>
   
    
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-body">
        <h5 className="card-title">Patient</h5>
        <div className="text-center mb-3">
          <div className="avatar-circle bg-info text-white mx-auto">
            {mobileDetailView.item.patient.prenom?.charAt(0)}{mobileDetailView.item.patient.nom?.charAt(0)}
          </div>
          <h5 className="mt-2">{mobileDetailView.item.patient.prenom} {mobileDetailView.item.patient.nom}</h5>
          <span className="badge bg-secondary">
            {calculateAge(mobileDetailView.item.patient.dateNaissance)} ans
          </span>
        </div>
        
        <div className="mb-2">
          <strong>Date de naissance:</strong> {new Date(mobileDetailView.item.patient.dateNaissance).toLocaleDateString()}
        </div>
        
        <div className="mb-2">
          <strong>Téléphone:</strong> {mobileDetailView.item.patient.telephone || 'Non spécifié'}
        </div>
        
        <div className="mb-2">
          <strong>Email:</strong> {mobileDetailView.item.patient.email || 'Non spécifié'}
        </div>
      </div>
    </div>
    
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-header bg-white">
        <h5 className="card-title mb-0">Rendez-vous</h5>
      </div>
      <div className="card-body" style={{ maxHeight: '200px', overflowY: 'auto' }}>
        {mobileDetailView.item.rendezVous && mobileDetailView.item.rendezVous.length > 0 ? (
          mobileDetailView.item.rendezVous.map((rdv, index) => (
            <div key={index} className={`rdv-item-mobile status-${rdv.statut} mb-2 p-2 border-bottom`}>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <small>{new Date(rdv.date).toLocaleDateString()} à {rdv.heure}</small>
                  <div>{rdv.structureName}</div>
                  <small className="text-muted">{rdv.motif || 'Aucun motif spécifié'}</small>
                </div>
                <span className={`badge status-badge-${rdv.statut}`}>
                  {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                </span>
              </div>
            </div>
          ))
        ) : (
          <p className="text-muted">Aucun rendez-vous enregistré</p>
        )}
      </div>
    </div>
    
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-header bg-white">
        <h5 className="card-title mb-0">Notes</h5>
      </div>
      <div className="card-body">
        <div className="mb-3">
          <textarea 
            className="form-control" 
            rows="4"
            value={archiveNotes}
            onChange={(e) => setArchiveNotes(e.target.value)}
            placeholder="Ajoutez vos notes concernant ce patient ici..."
          ></textarea>
        </div>
        <div className="d-grid">
          <button 
            className="btn btn-primary"
            onClick={() => {
              handleSaveArchiveNotes();
              // Afficher un toast de confirmation
              const toast = document.createElement('div');
              toast.className = 'toast-notification';
              toast.textContent = 'Notes enregistrées';
              document.body.appendChild(toast);
              setTimeout(() => document.body.removeChild(toast), 2000);
            }}
          >
            <FontAwesomeIcon icon={faSave} className="me-2" />
            Enregistrer les notes
          </button>
        </div>
      </div>
    </div>
    
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-header bg-white d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">Fichiers</h5>
        <label htmlFor="mobileArchiveFile" className="btn btn-sm btn-outline-primary mb-0">
          <FontAwesomeIcon icon={faFileUpload} className="me-1" />
          Ajouter
        </label>
      </div>
      <div className="card-body">
        <input 
          type="file" 
          className="form-control d-none" 
          id="mobileArchiveFile" 
          onChange={handleArchiveFileChange}
        />
        
        {archiveFiles && archiveFiles.some(file => file.isNew) && (
          <div className="mb-3 p-2 bg-light rounded">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <strong>Fichiers à téléverser:</strong>
              </div>
              <button 
                className="btn btn-sm btn-primary"
                onClick={handleArchiveFileUpload}
              >
                <FontAwesomeIcon icon={faFileUpload} className="me-1" />
                Téléverser
              </button>
            </div>
            <div className="mt-2" style={{ maxHeight: '100px', overflowY: 'auto' }}>
              {archiveFiles.filter(file => file.isNew).map((file, index) => (
                <div key={`new-${index}`} className="small text-truncate">
                  <FontAwesomeIcon icon={faFileAlt} className="me-1 text-primary" />
                  {file.name}
                </div>
              ))}
            </div>
          </div>
        )}
        
        <div className="list-group" style={{ maxHeight: '200px', overflowY: 'auto' }}>
          {mobileDetailView.item.files && mobileDetailView.item.files
            .filter(file => !file.isNew)
            .map((file, index) => (
            <div key={index} className="list-group-item list-group-item-action py-2 px-3">
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-truncate" style={{ maxWidth: '70%' }}>
                  <FontAwesomeIcon icon={faFileAlt} className="me-2 text-primary" />
                  {file.name}
                </div>
                <div>
                  <button 
                    className="btn btn-sm btn-outline-primary me-1"
                    onClick={() => handleDownloadArchiveFile(file)}
                  >
                    <FontAwesomeIcon icon={faFileDownload} />
                  </button>
                  <button 
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => handleDeleteArchiveFile(file.id)}
                  >
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </button>
                </div>
              </div>
            </div>
          ))}
          {(!mobileDetailView.item.files || mobileDetailView.item.files.length === 0) && (
            <div className="text-center py-3 text-muted">
              Aucun fichier associé à ce patient
            </div>
          )}
        </div>
      </div>
    </div>
    
    <div className="d-grid gap-2 mb-4 px-2">
      <button 
        className="btn btn-danger"
        onClick={() => {
          if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement cette archive ?")) {
            handleDeleteArchive(mobileDetailView.item.id);
            setMobileDetailView(null);
          }
        }}
      >
        <FontAwesomeIcon icon={faTrashAlt} className="me-1" />
        Supprimer cette archive
      </button>
    </div>
  </div>
)}

{mobileDetailView && mobileDetailView.type === 'date-events' && (
  <div className="mobile-detail-view" style={{ 
    position: 'fixed', 
    top: '56px',
    left: 0, 
    right: 0, 
    bottom: '56px',
    overflowY: 'auto',
    backgroundColor: '#fff',
    zIndex: 900,
    padding: '15px'
  }}>
    <h5 className="mb-3">{mobileDetailView.title}</h5>
    
    {mobileDetailView.item.events.map(rdv => (
      <div key={rdv.id} className={`card mb-3 border-left-${rdv.statut}`}>
        <div className="card-body py-2">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <strong>{rdv.heure}</strong> - {rdv.patientNom || 'Patient non spécifié'}
            </div>
            <div className="dropdown status-dropdown">
              <button 
                className={`btn btn-sm status-btn status-btn-${rdv.statut} dropdown-toggle`} 
                type="button"
                id={`statusDropdown-${rdv.id}`}
                data-bs-toggle="dropdown" 
                aria-expanded="false"
                onClick={(e) => e.stopPropagation()}
              >
                {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
              </button>
              <ul 
                className="dropdown-menu" 
                aria-labelledby={`statusDropdown-${rdv.id}`}
                style={{ zIndex: 1050 }}
              >
                <li><button className="dropdown-item" onClick={(e) => { e.stopPropagation(); handleChangeRdvStatus(rdv.id, 'confirmé'); }}>Confirmé</button></li>
                <li><button className="dropdown-item" onClick={(e) => { e.stopPropagation(); handleChangeRdvStatus(rdv.id, 'terminé'); }}>Terminé</button></li>
                <li><button className="dropdown-item" onClick={(e) => { e.stopPropagation(); handleChangeRdvStatus(rdv.id, 'annulé'); }}>Annulé</button></li>
              </ul>
            </div>
          </div>
          <div className="small text-muted">
            {getStructureById(rdv.structureId).nom}
          </div>
          {rdv.motif && <div className="small">{rdv.motif}</div>}
          
          <div className="d-flex justify-content-between align-items-center mt-2">
            <button 
              className="btn btn-sm btn-outline-primary" 
              onClick={(e) => { e.stopPropagation(); handleMobileDetailView('rdv', rdv); }}
            >
              <FontAwesomeIcon icon={faEye} className="me-1" />
              Détails
            </button>
            
            {rdv.patientId && (
              <button 
                className="btn btn-sm btn-outline-secondary"
                onClick={(e) => { e.stopPropagation(); handleViewPatient(rdv.patientId); }}
              >
                <FontAwesomeIcon icon={faUser} className="me-1" />
                Patient
              </button>
            )}
          </div>
        </div>
      </div>
    ))}
    
    {mobileDetailView.item.events.length === 0 && (
      <div className="alert alert-info">
        Aucun rendez-vous pour cette date
      </div>
    )}
    
    {/* Espace supplémentaire en bas pour éviter que le dernier élément soit caché */}
    <div style={{ height: '20px' }}></div>
  </div>
)}

<DetailView 
  showDetails={showDetails}
  setShowDetails={setShowDetails}
  detailsType={detailsType}
  detailsItem={detailsItem}
  isMobile={isMobile}
  // Archives
  archiveNotes={archiveNotes}
  setArchiveNotes={setArchiveNotes}
  archiveFiles={archiveFiles}
  // Rdv
  editingStatus={editingStatus}
  newStatus={newStatus}
  setNewStatus={setNewStatus}
  // Functions
  calculateAge={calculateAge}
  getStructureById={getStructureById}
  getPatientById={getPatientById}
  handleSaveArchiveNotes={handleSaveArchiveNotes}
  handleArchiveFileChange={handleArchiveFileChange}
  handleArchiveFileUpload={handleArchiveFileUpload}
  handleDownloadArchiveFile={handleDownloadArchiveFile}
  handleDeleteArchiveFile={handleDeleteArchiveFile}
  handleDeleteArchive={handleDeleteArchive}
  startEditStatus={startEditStatus}
  saveStatusChange={saveStatusChange}
  cancelEditStatus={cancelEditStatus}
/>

      </div>
    );
  }

  // Interface desktop
  return (
    <div className="dashboard-container">
      {/* Menu latéral */}
      <div className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <h3>{!sidebarCollapsed && `Dr. ${medecinData?.prenom} ${medecinData?.nom}`}</h3>
          <button className="toggle-btn" onClick={toggleSidebar}>
            <FontAwesomeIcon icon={sidebarCollapsed ? faChevronRight : faChevronLeft} />
          </button>
        </div>
        
        <div className="sidebar-menu">
          <ul>
            <li className={activeTab === 'info' ? 'active' : ''} onClick={() => setActiveTab('info')}>
              <FontAwesomeIcon icon={faUserMd} />
              {!sidebarCollapsed && <span>Mon Profil</span>}
            </li>
            <li className={activeTab === 'rendezvous' ? 'active' : ''} onClick={() => setActiveTab('rendezvous')}>
              <FontAwesomeIcon icon={faCalendarAlt} />
              {!sidebarCollapsed && <span>Rendez-vous</span>}
              <span className="badge bg-info">{rendezvous.length}</span>
            </li>
            <li className={activeTab === 'patients' ? 'active' : ''} onClick={() => setActiveTab('patients')}>
              <FontAwesomeIcon icon={faUser} />
              {!sidebarCollapsed && <span>Patients</span>}
              <span className="badge bg-info">{patients.length}</span>
            </li>

            <li className={activeTab === 'messagerie' ? 'active' : ''} onClick={() => setActiveTab('messagerie')}>
              <FontAwesomeIcon icon={faComments} />
              {!sidebarCollapsed && <span>Messagerie</span>}
              {unreadMessagesCount > 0 && <span className="badge bg-danger">{unreadMessagesCount}</span>}
            </li>


            <li className={activeTab === 'affiliations' ? 'active' : ''} onClick={() => setActiveTab('affiliations')} style={{ position: 'relative' }}>
              <FontAwesomeIcon icon={faClinicMedical} />
              {!sidebarCollapsed && <span>Affiliations</span>}
              {pendingAffiliations.length > 0 && 
                <span className="badge bg-danger" style={{
                  position: 'absolute',
                  top: '5px',
                  right: sidebarCollapsed ? '5px' : '15px',
                  fontSize: '0.75rem',
                  fontWeight: 'bold',
                  padding: '0.35em 0.65em',
                  borderRadius: '50%',
                  minWidth: '20px',
                  height: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>{pendingAffiliations.length}</span>
              }
            </li>
            {/* Dans la sidebar */}
              <li className={activeTab === 'archives' ? 'active' : ''} onClick={() => setActiveTab('archives')}>
                <FontAwesomeIcon icon={faArchive} />
                {!sidebarCollapsed && <span>Archives</span>}
              </li>
  
            <li className={activeTab === 'password' ? 'active' : ''} onClick={() => setActiveTab('password')}>
              <FontAwesomeIcon icon={faKey} />
              {!sidebarCollapsed && <span>Mot de passe</span>}
            </li>
            <li onClick={handleLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} />
              {!sidebarCollapsed && <span>Déconnexion</span>}
            </li>
          </ul>
        </div>
      </div>

      {/* Contenu principal */}
      <div className={`main-content ${sidebarCollapsed ? 'expanded' : ''}`}>
        {/* En-tête avec le titre de la section active */}
        <div className="content-header">
          <h2>
            {activeTab === 'info' && 'Mon Profil'}
            {activeTab === 'rendezvous' && 'Mes Rendez-vous'}
            {activeTab === 'patients' && 'Mes Patients'}
            {activeTab === 'messagerie' && 'Messagerie'}
            {activeTab === 'affiliations' && 'Mes Affiliations'}
            {activeTab === 'password' && 'Modification du mot de passe'}
          </h2>
        </div>

        {/* Affichage des messages de notification */}
        {message && (
          <div className={`alert alert-dismissible fade show ${message.includes('Erreur') ? 'alert-danger' : 'alert-success'}`} role="alert">
            {message}
            <button type="button" className="btn-close" onClick={() => setMessage('')}></button>
          </div>
        )}

        {/* Contenu des différents onglets */}
        <div className="content-body">
          {/* Onglet Mon Profil */}
          {activeTab === 'info' && (
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4 text-center mb-4">
                    <div className="avatar-circle bg-primary text-white mx-auto">
                      {medecinData?.prenom?.charAt(0)}{medecinData?.nom?.charAt(0)}
                    </div>
                    <h4 className="mt-3">Dr. {medecinData?.prenom} {medecinData?.nom}</h4>
                    <span className="badge bg-info">{medecinData?.specialite}</span>
                  </div>
                  <div className="col-md-8">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Nom</label>
                        <input
                          name="nom"
                          value={form.nom || ''}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Nom"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Prénom</label>
                        <input
                          name="prenom"
                          value={form.prenom || ''}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Prénom"
                        />
                      </div>
                    </div>
                    
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Spécialité</label>
                        <input
                          name="specialite"
                          value={form.specialite || ''}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Spécialité"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Téléphone</label>
                        <input
                          name="telephone"
                          value={form.telephone || ''}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Téléphone"
                        />
                      </div>
                    </div>
                    
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        name="email"
                        value={form.email || ''}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Email"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Disponibilités</label>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Jour</th>
                          <th>Disponible</th>
                          <th>Heure de début</th>
                          <th>Heure de fin</th>
                        </tr>
                      </thead>
                      <tbody>
                        {form.disponibilites && Object.entries(form.disponibilites).map(([jour, dispo]) => (
                          <tr key={jour}>
                            <td>{jour.charAt(0).toUpperCase() + jour.slice(1)}</td>
                            <td>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`disponible-${jour}`}
                                  name={`disponibilites.${jour}.actif`}
                                  checked={dispo.actif || false}
                                  onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor={`disponible-${jour}`}>
                                  {dispo.actif ? 'Oui' : 'Non'}
                                </label>
                              </div>
                            </td>
                            <td>
                              <input
                                type="time"
                                className="form-control"
                                name={`disponibilites.${jour}.debut`}
                                value={dispo.debut || '08:00'}
                                onChange={handleChange}
                                disabled={!dispo.actif}
                              />
                            </td>
                            <td>
                              <input
                                type="time"
                                className="form-control"
                                name={`disponibilites.${jour}.fin`}
                                value={dispo.fin || '18:00'}
                                onChange={handleChange}
                                disabled={!dispo.actif}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                
                <div className="text-end mt-3">
                  <button onClick={handleUpdate} className="btn btn-primary">
                    <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                    Mettre à jour
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Onglet Rendez-vous */}
          {activeTab === 'rendezvous' && (
            <div>
              <div className="card shadow-sm mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <div className="btn-group">
                    <button 
                      className={`btn ${viewMode === 'calendar' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => setViewMode('calendar')}
                    >
                      <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                      Vue Calendrier
                    </button>
                    <button 
                      className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => setViewMode('list')}
                    >
                      <FontAwesomeIcon icon={faList} className="me-2" />
                      Vue Liste
                    </button>
                  </div>
                  
                  <div className="d-flex align-items-center">
                    <div className="input-group me-2" style={{ maxWidth: '200px' }}>
                      <span className="input-group-text">Date</span>
                      <input 
                        type="date" 
                        className="form-control" 
                        value={filtreDate}
                        onChange={(e) => setFiltreDate(e.target.value)}
                      />
                    </div>
                    
                    <select 
                      className="form-select me-2" 
                      style={{ maxWidth: '150px' }}
                      value={filtreStatut}
                      onChange={(e) => setFiltreStatut(e.target.value)}
                    >
                      <option value="tous">Tous statuts</option>
                      <option value="confirmé">Confirmé</option>
                      <option value="terminé">Terminé</option>
                      <option value="annulé">Annulé</option>
                    </select>
                    
                    <select 
  className="form-select" 
  style={{ maxWidth: '200px' }}
  value={filtreStructure}
  onChange={(e) => setFiltreStructure(e.target.value)}
>
  <option value="">Toutes structures</option>
  {affiliatedStructures.map(structure => (
    <option key={structure.id} value={structure.id}>
      {structure.nom}
    </option>
  ))}
</select>
                  </div>
                </div>
                
                <div className="card-body">
                  {viewMode === 'calendar' ? (
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <button className="btn btn-outline-secondary" onClick={handlePrevMonth}>
                          <FontAwesomeIcon icon={faChevronLeft} className="me-1" />
                          Mois précédent
                        </button>
                        <h4 className="mb-0">
                          {currentMonth.toLocaleString('fr-FR', { month: 'long', year: 'numeric' })}
                        </h4>
                        <button className="btn btn-outline-secondary" onClick={handleNextMonth}>
                          Mois suivant
                          <FontAwesomeIcon icon={faChevronRight} className="ms-1" />
                        </button>
                      </div>
                      
                      <div className="calendar-container">
                        <div className="calendar-header">
                          {['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'].map((day, index) => (
                            <div key={index} className="calendar-cell header">
                              {day}
                            </div>
                          ))}
                        </div>
                        <div className="calendar-body">
                          {getMonthData().map((day, index) => (
                            <div 
                              key={index} 
                              className={`calendar-cell ${!day.isCurrentMonth ? 'other-month' : ''} ${day.hasEvents ? 'has-events' : ''}`}
                              onClick={() => handleDateClick(day)}
                            >
                              <div className="date-number">{day.date.getDate()}</div>
                              {day.hasEvents && (
                                <div className="event-indicator">
                                  <span className="badge rounded-pill bg-primary">
                                    {day.events.length} {day.events.length > 1 ? 'rendez-vous' : 'rendez-vous'}
                                  </span>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Heure</th>
                            <th>Patient</th>
                            <th>Structure</th>
                            <th>Motif</th>
                            <th>Statut</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredRendezvous.length > 0 ? (
                            filteredRendezvous.map(rdv => (
                              <tr key={rdv.id} className={`status-row-${rdv.statut}`}>
                                <td>{new Date(rdv.date).toLocaleDateString()}</td>
                                <td>{rdv.heure}</td>
                                <td>
                                  {rdv.patientNom || 'Non spécifié'}
                                  {rdv.patientId && (
                                    <button 
                                      className="btn btn-sm btn-link p-0 ms-2"
                                      onClick={() => handleViewPatient(rdv.patientId)}
                                      title="Voir les détails du patient"
                                    >
                                      <FontAwesomeIcon icon={faEye} />
                                    </button>
                                  )}
                                </td>
                                <td>{getStructureById(rdv.structureId).nom}</td>
                                <td>{rdv.motif || 'Non spécifié'}</td>
                                <td>
                                  <span className={`badge status-badge-${rdv.statut}`}>
                                    {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                                  </span>
                                </td>
                                <td>
                                  <button 
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => handleViewDetails('rdv', rdv)}
                                  >
                                    <FontAwesomeIcon icon={faEye} className="me-1" />
                                    Détails
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center py-3">
                                Aucun rendez-vous trouvé
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

{activeTab === 'patients' && (
  <div>
    {/* Navigation interne */}
    <ul className="nav nav-tabs mb-4">
      <li className="nav-item">
        <button 
          className={`nav-link ${patientSubTab === 'list' ? 'active' : ''}`}
          onClick={() => setPatientSubTab('list')}
        >
          Liste des patients
        </button>
      </li>
      <li className="nav-item">
        <button 
          className={`nav-link ${patientSubTab === 'manage' ? 'active' : ''}`}
          onClick={() => setPatientSubTab('manage')}
        >
          Gestion des patients
        </button>
      </li>
    </ul>
    
    {/* Contenu conditionnel basé sur l'onglet sélectionné */}
    {patientSubTab === 'list' && (
      <div className="card shadow-sm">
        <div className="card-header bg-light">
          <h5 className="mb-0">Mes patients</h5>
        </div>
        <div className="card-body">
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            {patients.length > 0 ? (
              patients.map((patient) => {
                // Trouver les rendez-vous associés à ce patient
                const patientRdvs = rendezvous.filter(rdv => rdv.patientId === patient.id);
                // Trouver les structures uniques associées aux rendez-vous
                const structureIds = [...new Set(patientRdvs.map(rdv => rdv.structureId))];
                const patientStructures = structureIds.map(id => getStructureById(id));
                
                return (
                  <div className="col" key={patient.id}>
                    <div className="card h-100 shadow-sm hover-card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start">
                          <h5 className="card-title">{patient.prenom} {patient.nom}</h5>
                          <span className="badge bg-secondary">
                            {calculateAge(patient.dateNaissance)} ans
                          </span>
                        </div>
                        <div className="row mt-2">
                          <div className="col-12 col-sm-6">
                            <p className="card-text small mb-1">
                              <i className="fas fa-phone me-2 text-secondary"></i>
                              {patient.telephone || 'Non spécifié'}
                            </p>
                          </div>
                          <div className="col-12 col-sm-6">
                            <p className="card-text small mb-1">
                              <i className="fas fa-envelope me-2 text-secondary"></i>
                              {patient.email || 'Non spécifié'}
                            </p>
                          </div>
                          <div className="col-12 col-sm-6">
                            <p className="card-text small mb-1">
                              <i className="fas fa-diagnoses me-2 text-secondary"></i>
                              {patient.diagnostics || 'Non spécifié'}
                            </p>
                          </div>
                        </div>
                        {patientStructures.length > 0 && (
                          <div className="mt-2">
                            <h6 className="fs-7 mb-1">Structures associées:</h6>
                            <div className="d-flex flex-wrap">
                              {patientStructures.map((structure, index) => (
                                <span key={index} className="badge bg-light text-dark me-1 mb-1">
                                  {structure.nom}
                                </span>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="card-footer bg-transparent border-top-0">
                        <div className="d-flex justify-content-between">
                          <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => handleManualArchivePatient(patient)}
                            title="Archiver ce patient"
                          >
                            <FontAwesomeIcon icon={faArchive} className="me-1" />
                            Archiver
                          </button>
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => handleViewDetails('patient', getPatientById(patient.id))}
                          >
                            <FontAwesomeIcon icon={faEye} className="me-1" />
                            Voir détails
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-12 text-center py-5">
                <p className="text-muted">Aucun patient associé à vos rendez-vous</p>
              </div>
            )}
          </div>
        </div>
      </div>
    )}
    
    {patientSubTab === 'manage' && (
      <div className="card shadow-sm">
        <div className="card-header bg-light">
          <h5 className="mb-0">Gestion des patients</h5>
        </div>
        <div className="card-body">
          <MedecinPatientManager 
            medecinId={auth.currentUser?.uid}
            affiliatedStructures={affiliatedStructures}
            patients={patients}
            onPatientAdd={(newPatient) => {
              setPatients(prevPatients => [...prevPatients, newPatient]);
            }}
            onPatientUpdate={(updatedPatient) => {
              setPatients(prevPatients => 
                prevPatients.map(p => p.id === updatedPatient.id ? updatedPatient : p)
              );
            }}
            onPatientArchive={(patientId) => {
              // Mettre à jour l'état pour refléter l'archivage
              setPatients(prevPatients => 
                prevPatients.map(p => p.id === patientId ? {...p, archived: true} : p)
              );
            }}
          />
        </div>
      </div>
    )}
  </div>
)}




          {/* Onglet Affiliations */}
          {activeTab === 'affiliations' && (
            <div>
              {/* Recherche et demande d'affiliation à de nouvelles structures */}
              <div className="card shadow-sm mb-4">
  <div className="card-header d-flex justify-content-between align-items-center">
    <h5 className="mb-0">Rechercher des structures</h5>
    <div>
      <button 
        className="btn btn-sm btn-outline-secondary me-2"
        onClick={cleanupAffiliationRequests}
        title="Nettoyer les demandes obsolètes"
      >
        <FontAwesomeIcon icon={faBroom} />
      </button>
      <button 
        className="btn btn-sm btn-outline-secondary"
        onClick={refreshAffiliations}
        disabled={loading}
      >
        <FontAwesomeIcon icon={faRedo} className={loading ? "fa-spin" : ""} />
        {!loading && <span className="ms-1">Rafraîchir</span>}
      </button>
    </div>
  </div>
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-md-8">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Rechercher une structure par nom ou spécialité..."
                          value={searchStructure}
                          onChange={(e) => setSearchStructure(e.target.value)}
                        />
                        <button className="btn btn-outline-primary" type="button">
                          <FontAwesomeIcon icon={faSearch} className="me-1" />
                          Rechercher
                        </button>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <select 
                        className="form-select"
                        value={filtreSpecialite}
                        onChange={(e) => setFiltreSpecialite(e.target.value)}
                      >
                        <option value="">Toutes spécialités</option>
                        {specialites.map((specialite, index) => (
                          <option key={index} value={specialite}>{specialite}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Structure</th>
                          <th>Spécialités</th>
                          <th>Adresse</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredStructures.length > 0 ? (
                          filteredStructures.map(structure => {
                            // Vérifier si déjà affilié ou demande en cours
                            const isAffiliated = affiliatedStructures.some(s => s.id === structure.id);
                            const hasPendingRequest = sentAffiliationRequests.some(req => 
                              req.structureId === structure.id && req.status === "pending"
                            );
                            const hasRejectedRequest = sentAffiliationRequests.some(req => 
                              req.structureId === structure.id && req.status === "rejected"
                            );
                            
                            return (
                              <tr key={structure.id}>
                                <td>{structure.nom}</td>
                                <td>
                                  {Array.isArray(structure.specialites) ? (
                                    structure.specialites.map((specialite, index) => (
                                      <span key={index} className="badge bg-light text-dark me-1 mb-1">
                                        {specialite}
                                      </span>
                                    ))
                                  ) : (
                                    <span className="text-muted">Aucune spécialité</span>
                                  )}
                                </td>
                                <td>{structure.adresse || 'Non spécifiée'}</td>
                                <td>
                                  {isAffiliated ? (
                                    <button 
                                      className="btn btn-sm btn-outline-danger"
                                      onClick={() => handleDesaffiliation(structure.id)}
                                    >
                                      <FontAwesomeIcon icon={faUnlink} className="me-1" />
                                      Se désaffilier
                                    </button>
                                  ) : hasPendingRequest ? (
                                    <span className="badge bg-warning text-dark">Demande en attente</span>
                                  ) : hasRejectedRequest ? (
                                    <span className="badge bg-danger">Demande rejetée</span>
                                  ) : (
                                    <button 
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() => handleRequestAffiliation(structure.id)}
                                    >
                                      <FontAwesomeIcon icon={faLink} className="me-1" />
                                      Demander affiliation
                                    </button>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center py-3">
                              Aucune structure trouvée
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              
              {/* Demandes d'affiliation en cours */}
              <div className="card shadow-sm mb-4">
                <div className="card-header">
                  <h5>Mes demandes d'affiliation en cours</h5>
                </div>
                <div className="card-body">
                  {sentAffiliationRequests.filter(req => req.status === "pending").length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Structure</th>
                            <th>Date de la demande</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sentAffiliationRequests.filter(req => req.status === "pending").map(request => (
                            <tr key={request.id}>
                              <td>{request.structureName}</td>
                              <td>{new Date(request.createdAt.toDate()).toLocaleDateString()}</td>
                              <td>
                                <button 
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => handleCancelRequest(request.id)}
                                >
                                  <FontAwesomeIcon icon={faTimes} className="me-1" />
                                  Annuler
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="alert alert-info">
                      Aucune demande d'affiliation en cours
                    </div>
                  )}
                </div>
              </div>
              
              {/* Structures affiliées */}
              <div className="card shadow-sm">
                <div className="card-header">
                  <h5>Mes structures affiliées</h5>
                </div>
                <div className="card-body">
                  {affiliatedStructures.length > 0 ? (
                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                      {affiliatedStructures.map(structure => (
                        <div className="col" key={structure.id}>
                          <div className="card h-100 shadow-sm hover-card">
                            <div className="card-body">
                              <h5 className="card-title">{structure.nom}</h5>
                              <p className="card-text">
                                <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                                {structure.telephone || 'Non spécifié'}
                              </p>
                              <p className="card-text">
                                <FontAwesomeIcon icon={faEnvelope} className="me-2 text-secondary" />
                                {structure.email || 'Non spécifié'}
                              </p>
                              <p className="card-text">
                                <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-secondary" />
                                {structure.adresse || 'Adresse non spécifiée'}
                              </p>
                             
                            </div>
                            <div className="card-footer bg-transparent">
                              <button 
                                className="btn btn-sm btn-outline-danger w-100"
                                onClick={() => handleDesaffiliation(structure.id)}
                              >
                                <FontAwesomeIcon icon={faUnlink} className="me-1" />
                                Se désaffilier
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="alert alert-info">
                      Aucune structure affiliée
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

{/* Onglet Archives */}
{activeTab === 'archives' && (
  <div>
    <div className="card shadow-sm mb-4">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Archives des patients</h5>
        <div className="input-group" style={{ maxWidth: '300px' }}>
          <input
            type="text"
            className="form-control"
            placeholder="Rechercher un patient..."
            value={searchArchive}
            onChange={(e) => setSearchArchive(e.target.value)}
          />
          <button className="btn btn-outline-primary" type="button">
            <FontAwesomeIcon icon={faSearch} />
          </button>
        </div>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>Patient</th>
                <th>Dernière visite</th>
                <th>Nombre de RDV</th>
                <th>Notes</th>
                <th>Fichiers</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {archives.filter(archive => 
                archive.patient.nom.toLowerCase().includes(searchArchive.toLowerCase()) ||
                archive.patient.prenom.toLowerCase().includes(searchArchive.toLowerCase())
              ).map(archive => (
                <tr key={archive.id}>
                  <td>{archive.patient.prenom} {archive.patient.nom}</td>
                  <td>{new Date(archive.lastVisit).toLocaleDateString()}</td>
                  <td>{archive.rdvCount}</td>
                  <td>
                    {archive.notes ? (
                      <span className="badge bg-info">Oui</span>
                    ) : (
                      <span className="badge bg-secondary">Non</span>
                    )}
                  </td>
                  <td>{archive.files?.length || 0}</td>
                  <td>
                    <button 
                      className="btn btn-sm btn-outline-primary me-1"
                      onClick={() => handleViewArchive(archive)}
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                    <button 
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDeleteArchive(archive.id)}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                  </td>
                </tr>
              ))}
              {archives.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center py-3">
                    Aucune archive trouvée
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
)}

          {/* Onglet Messagerie */}
         {/* Onglet Messagerie */}
         {activeTab === 'messagerie' && (
            <div className="card shadow-sm">
              <div className="card-body p-0">
                <div className="messaging-container">
                  <div className="conversations-sidebar">
                    <div className="conversations-header">
                      <h5 className="mb-3">Conversations</h5>
                      <div className="input-group mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Rechercher un patient..."
                          value={searchPatientTerm}
                          onChange={(e) => setSearchPatientTerm(e.target.value)}
                        />
                        <button className="btn btn-outline-primary" type="button">
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </div>
                    </div>
                    
                    <div className="patients-list">
                      <h6 className="sidebar-heading">Patients</h6>
                      {filteredMessagePatients.length > 0 ? (
                        <div className="list-group list-group-flush">
                          {filteredMessagePatients.map(patient => (
                            <button
                              key={patient.id}
                              className="list-group-item list-group-item-action d-flex align-items-center"
                              onClick={() => startConversationWithPatient(patient)}
                            >
                              <div className="avatar-mini me-2">
                                {patient.prenom?.[0]}{patient.nom?.[0]}
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>{patient.prenom} {patient.nom}</span>
                                </div>
                              </div>
                            </button>
                          ))}
                        </div>
                      ) : (
                        <p className="text-muted text-center">Aucun patient trouvé</p>
                      )}
                    </div>
                    
                    <div className="conversations-list">
                      <h6 className="sidebar-heading">Conversations récentes</h6>
                      {conversations.length > 0 ? (
                        <div className="list-group list-group-flush">
                          {conversations.map(conversation => (
                            <button
                              key={conversation.id}
                              className={`list-group-item list-group-item-action d-flex align-items-center ${selectedConversation?.id === conversation.id ? 'active' : ''}`}
                              onClick={() => setSelectedConversation(conversation)}
                            >
                              <div className="avatar-mini me-2">
                                {conversation.patient?.prenom?.[0]}{conversation.patient?.nom?.[0]}
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>{conversation.patient?.prenom} {conversation.patient?.nom}</span>
                                  {conversation.unreadCount > 0 && (
                                    <span className="badge bg-danger rounded-pill">{conversation.unreadCount}</span>
                                  )}
                                </div>
                                <small className="text-muted">
                                  {conversation.lastMessage || "Nouvelle conversation"}
                                </small>
                              </div>
                            </button>
                          ))}
                        </div>
                      ) : (
                        <p className="text-muted text-center">Aucune conversation</p>
                      )}
                    </div>
                  </div>
                  
                  <div className="messages-area">
                    {selectedConversation ? (
                      <>
                        <div className="messages-header">
                          <div className="d-flex align-items-center">
                            <div className="avatar-mini me-2">
                              {selectedConversation.patient?.prenom?.[0]}{selectedConversation.patient?.nom?.[0]}
                            </div>
                            <div>
                              <h5 className="mb-0">{selectedConversation.patient?.prenom} {selectedConversation.patient?.nom}</h5>
                            </div>
                          </div>
                        </div>
                        
                        <div className="messages-container">
                          {loadingMessages ? (
                            <div className="text-center p-4">
                              <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Chargement...</span>
                              </div>
                            </div>
                          ) : messages.length === 0 ? (
                            <div className="text-center p-4">
                              <FontAwesomeIcon icon={faComment} size="3x" className="text-muted mb-3" />
                              <p>Aucun message. Commencez la conversation!</p>
                            </div>
                          ) : (
                            <div className="messages-list">
                              {messages.map(message => {
                                const isOwn = message.senderId === auth.currentUser.uid;
                                return (
                                  <div key={message.id} className={`message ${isOwn ? 'message-own' : 'message-other'}`}>
                                    <div className="message-content">
                                      <div className="message-text">{message.text}</div>
                                      <div className="message-time">
                                        {message.timestamp ? 
                                          new Date(message.timestamp.toDate()).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}) : 
                                          'Envoi...'}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                              <div ref={messagesEndRef} />
                            </div>
                          )}
                        </div>
                        
                        <form className="message-input-form" onSubmit={sendMessage}>
                          {attachmentFile && (
                            <div className="attachment-preview">
                              <div className="attachment-info">
                                <FontAwesomeIcon icon={faFile} className="me-2" />
                                <span>{attachmentFile.name}</span>
                              </div>
                              <button type="button" className="btn-close" onClick={removeAttachment}></button>
                            </div>
                          )}
                          
                          {audioBlob && !isRecording && (
                            <div className="attachment-preview">
                              <div className="attachment-info">
                                <FontAwesomeIcon icon={faMicrophone} className="me-2" />
                                <span>Note vocale ({formatRecordingTime(recordingTime)})</span>
                              </div>
                              <button type="button" className="btn-close" onClick={removeAudio}></button>
                            </div>
                          )}
                          
                          {isRecording && (
                            <div className="recording-indicator">
                              <div className="pulse"></div>
                              <span>Enregistrement en cours... {formatRecordingTime(recordingTime)}</span>
                              <div className="recording-controls">
                                <button type="button" className="btn btn-danger btn-sm" onClick={cancelRecording}>
                                  <FontAwesomeIcon icon={faTimes} />
                                </button>
                                <button type="button" className="btn btn-success btn-sm" onClick={stopRecording}>
                                  <FontAwesomeIcon icon={faCheck} />
                                </button>
                              </div>
                            </div>
                          )}
                          
                          <div className="input-group">
                            <button 
                              type="button" 
                              className="btn btn-light" 
                              onClick={() => document.getElementById('file-attachment').click()}
                            >
                              <FontAwesomeIcon icon={faPaperclip} />
                            </button>
                            <input 
                              id="file-attachment" 
                              type="file" 
                              className="d-none" 
                              onChange={handleMessageFileChange} 
                            />
                            
                            <button 
                              type="button" 
                              className={`btn ${isRecording ? 'btn-danger' : 'btn-light'}`}
                              onClick={isRecording ? stopRecording : startRecording}
                            >
                              <FontAwesomeIcon icon={isRecording ? faStop : faMicrophone} />
                            </button>
                            
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Écrivez votre message..."
                              value={newMessage}
                              onChange={(e) => setNewMessage(e.target.value)}
                              disabled={sendingMessage || isRecording}
                            />
                            <button 
                              className="btn btn-primary" 
                              type="submit"
                              disabled={((!newMessage.trim() && !attachmentFile && !audioBlob) || sendingMessage || isRecording)}
                            >
                              {sendingMessage ? (
                                <FontAwesomeIcon icon={faCircleNotch} spin />
                              ) : (
                                <FontAwesomeIcon icon={faPaperPlane} />
                              )}
                            </button>
                          </div>
                        </form>
                      </>
                    ) : (
                      <div className="no-conversation-selected">
                        <FontAwesomeIcon icon={faComments} size="3x" className="text-muted mb-3" />
                        <h5>Sélectionnez une conversation</h5>
                        <p className="text-muted">Choisissez un patient pour commencer à discuter</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}


          {/* Onglet Mot de passe */}
          {activeTab === 'password' && (
            <div className="card shadow-sm">
              <div className="card-body">
                <form onSubmit={(e) => { e.preventDefault(); handlePasswordChange(); }}>
                  <div className="mb-3">
                    <label className="form-label">Nouveau mot de passe</label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="text-end">
                    <button type="submit" className="btn btn-primary">
                      <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                      Mettre à jour le mot de passe
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}


  
        </div>
      </div>


      <DetailView 
  showDetails={showDetails}
  setShowDetails={setShowDetails}
  detailsType={detailsType}
  detailsItem={detailsItem}
  isMobile={isMobile}
  // Archives
  archiveNotes={archiveNotes}
  setArchiveNotes={setArchiveNotes}
  archiveFiles={archiveFiles}
  // Rdv
  editingStatus={editingStatus}
  newStatus={newStatus}
  setNewStatus={setNewStatus}
  // Functions
  calculateAge={calculateAge}
  getStructureById={getStructureById}
  getPatientById={getPatientById}
  handleSaveArchiveNotes={handleSaveArchiveNotes}
  handleArchiveFileChange={handleArchiveFileChange}
  handleArchiveFileUpload={handleArchiveFileUpload}
  handleDownloadArchiveFile={handleDownloadArchiveFile}
  handleDeleteArchiveFile={handleDeleteArchiveFile}
  handleDeleteArchive={handleDeleteArchive}
  startEditStatus={startEditStatus}
  saveStatusChange={saveStatusChange}
  cancelEditStatus={cancelEditStatus}
/>

<style jsx>{`/* Styles pour la messagerie */
.messaging-container {
  display: flex;
  height: 70vh;
  overflow: hidden;
}

.conversations-sidebar {
  width: 300px;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.conversations-header {
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.sidebar-heading {
  font-size: 0.875rem;
  text-transform: uppercase;
  color: #6c757d;
  padding: 10px 15px;
  margin: 0;
  background-color: #f8f9fa;
}

.patients-list, .conversations-list {
  flex: 1;
  overflow-y: auto;
}

.avatar-mini {
  width: 40px;
  height: 40px;
  background-color: #007bff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.messages-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.messages-header {
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
}

.messages-container {
  flex: 1;
  padding: 15px;
  overflow-y: auto;
}

.messages-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.message {
  display: flex;
  max-width: 70%;
}

.message-own {
  align-self: flex-end;
}

.message-other {
  align-self: flex-start;
}

.message-content {
  padding: 10px 15px;
  border-radius: 18px;
  position: relative;
}

.message-own .message-content {
  background-color: #007bff;
  color: white;
  border-bottom-right-radius: 4px;
}

.message-other .message-content {
  background-color: #f0f0f0;
  color: #212529;
  border-bottom-left-radius: 4px;
}

.message-text {
  margin-bottom: 4px;
  word-break: break-word;
}

.message-time {
  font-size: 0.75rem;
  opacity: 0.7;
  text-align: right;
}

.message-input-form {
  padding: 15px;
  border-top: 1px solid #e0e0e0;
}

.no-conversation-selected {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #6c757d;
  text-align: center;
  padding: 20px;
}

/* Pour la version mobile */
@media (max-width: 767px) {
  .messaging-container {
    flex-direction: column;
    height: auto;
  }
  
  .conversations-sidebar {
    width: 100%;
    height: auto;
    max-height: 300px;
    border-right: none;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .messages-area {
    height: calc(100vh - 400px);
  }
}

/* Styles pour la messagerie mobile */
.mobile-messagerie-view {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 170px);
}

.mobile-conversation-header {
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  z-index: 10;
}

.mobile-messages-container {
  flex: 1;
  padding: 10px;
  overflow-y: auto;
}

.mobile-messages-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mobile-message {
  display: flex;
  max-width: 80%;
}

.mobile-message-own {
  align-self: flex-end;
}

.mobile-message-other {
  align-self: flex-start;
}

.mobile-message-content {
  padding: 8px 12px;
  border-radius: 18px;
  position: relative;
}

.mobile-message-own .mobile-message-content {
  background-color: #007bff;
  color: white;
  border-bottom-right-radius: 4px;
}

.mobile-message-other .mobile-message-content {
  background-color: #f0f0f0;
  color: #212529;
  border-bottom-left-radius: 4px;
}

.mobile-message-text {
  margin-bottom: 2px;
  word-break: break-word;
  font-size: 14px;
}

.mobile-message-time {
  font-size: 10px;
  opacity: 0.7;
  text-align: right;
}

.mobile-message-input-form {
  padding: 10px;
  border-top: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  position: sticky;
  bottom: 0;
}

.mobile-tabs {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
}

.mobile-tab {
  flex: 1;
  text-align: center;
  padding: 10px;
  background: none;
  border: none;
  font-weight: 500;
  color: #6c757d;
}

.mobile-tab.active {
  color: #007bff;
  border-bottom: 2px solid #007bff;
}

/* Styles pour le bouton de messagerie dans la navigation mobile */
.mobile-bottom-nav button.messaging-btn {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--ms-gray-130);
  font-size: 22px;
  padding: 8px;
  border: none;
  background: transparent;
  transition: color 0.2s ease;
}

.mobile-bottom-nav button.messaging-btn.active {
  color: var(--ms-blue);
}

.mobile-bottom-nav button.messaging-btn .unread-badge {
  position: absolute;
  top: 4px;
  right: 50%;
  transform: translateX(12px);
  background-color: var(--ms-red);
  color: white;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Styles pour la section messagerie mobile */

.attachment-preview {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f1f5f9;
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.attachment-info {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: #475569;
}

.recording-indicator {
  display: flex;
  align-items: center;
  background-color: #fee2e2;
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 8px;
  color: #b91c1c;
}

.pulse {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ef4444;
  margin-right: 10px;
  animation: pulse 1.5s infinite;
}

.recording-controls {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

  `}
</style>
    </div>

  );
};

export default MedecinDashboard;



